<!--Instructions Modal-->

<ng-template #compactchecklist let-modal>
  <div class="instructions-popup">
    <div class="modal-header">
      <div
        class="d-flex align-items-center justify-content-between"
        style="width: 100%"
      >
        <h2 class="modal-title" style="color: #24597a">
          {{ "HOME.INSTRUCTDOCUMENT" | translate }}
        </h2>
        <div class="header-actions">
          <button
            type="button"
            *ngIf="customizing?.triggerPrint != null"
            class="btn prints-btn"
            (click)="postPrintDetails('0', false)"
          >
            {{ "HOME.PRINTBUTTON" | translate }}
          </button>
          <button
            *ngIf="isD && selectedOption == 'checklist'"
            type="button"
            class="btn print-btn"
            (click)="addCompact(submitButton)"
            #submitButton
          >
            {{ "HOME.SAVEANDCLOSE" | translate }} 
          </button>
          <button
            *ngIf="!isD || (selectedOption != 'checklist' && isD)"
            type="button"
            class="btn print-btn"
            (click)=" modal.dismiss('Cross click')"
          >
            {{ "HOME.CLOSEBUTTON" | translate }} 
          </button>
          <ng-container
            [ngTemplateOutlet]="closeiconbutton" 
            [ngTemplateOutletContext]="{ modal: modal }" 
          ></ng-container>
        </div>
      </div>
    </div>
    <div class="modal-body">
      <div class="instructions-content">
        <div class="instructions-content-left">
          <ul>
            <li
              *ngIf="
                customizing?.showInstructions != null ||
                customizing?.showInstructions == goodsRecipt ||
                goodsRecipt == '' ||
                true
              "
            >
              <a
                [ngClass]="selectedOption == 'instructions' ? 'chacive bold' : ''"
                class="checklisinstruction "
                (click)="
                  setOption('instructions', '');
                  diactivatedFlag = false;
                  isD = true;
                  inputText = ''
                "
                >{{ "HOME.INSTRUCTIONS_LABEL" | translate }}</a
              >
            </li>
            <li>
              <a
                [ngClass]="{
                  'chacive bold': selectedOption == 'checklist'
                }"
                class="checklisinstruction"
                (click)="setOption('checklist', ''); isD = true"
                >{{ "HOME.CHECKLIST_LABEL" | translate }}</a
                >
              </li>
              <ng-container *ngIf="!this.pdfFlag">
                <li *ngFor="let items of attachments">
                  <a
                  [ngClass]="{
                    'chacive bold': selectedOption == items?.document_type
                  }"
                  class="checklisinstruction"
                  (click)="setOption(items?.document_type, items); isD = false"
                >
                  {{ items?.document_type }}</a
                >
              </li>
            </ng-container>
          </ul>
        </div>
        <div class="projectbody instructions-content-right-desktop">
          <ng-container *ngIf="isD && selectedOption == 'checklist'">
            <form novalidate [formGroup]="checkListFormGroup">
              <div class="mb-3" *ngFor="let list of checkListItems">
                <h5 class="compact-title">{{ list.title }}</h5>
                <div class="maint_container_list">
                  <ng-container *ngFor="let datas of list.header">
                    <div class="maint_container_list_details mb-2">
                      <ng-container [ngSwitch]="datas.fieldType">
                        <label
                          [attr.for]="datas.fieldName"
                          class="p-2 titelfont"
                          style="color: #24597a"
                          *ngSwitchCase="'label'"
                          >{{ datas?.value }}</label
                        >
                      </ng-container>
                    </div>
                  </ng-container>
                </div>
                <ng-container *ngFor="let item of list.body">
                  <div class="maint_container_list">
                    <ng-container *ngFor="let data of item">
                      <div class="maint_container_list_details mb-2">
                        <ng-container [ngSwitch]="data.fieldType">
                          <label
                            [attr.for]="data.fieldName"
                            class="p-2 titelfont"
                            style="color: #24597a"
                            *ngSwitchCase="'label'"
                            >{{ data?.value }}</label
                          >
                          <div *ngSwitchCase="'float'" class="number-input-wrapper">
                            <input
                              class="form-control"
                              pattern="-?[0-9]*\.?[0-9]*"
                              inputmode="decimal"
                              [formControlName]="data.fieldName"
                              [id]="data.fieldName"
                              type="number"
                              step="any"
                              [value]="data?.value"
                              [placeholder]="data?.placeholder ? data?.placeholder : ''"
                            />
                            <div class="spinner-buttons">
                              <button type="button" class="spin-btn spin-up"
                                      (click)="stepValue(data, 1, false)"
                                      [ngStyle]="{display: isFormDisabled(data.fieldID ?? data.fieldName) ? 'none' : undefined}"
                                      (pointerdown)="startSpin(data, 1, false)"
                                      (pointerup)="stopSpin()"
                                      (pointerleave)="stopSpin()">▲</button>
                              <button type="button" class="spin-btn spin-down"
                                      (click)="stepValue(data, -1, false)"
                                      [ngStyle]="{display: isFormDisabled(data.fieldID ?? data.fieldName) ? 'none' : undefined}"
                                      (pointerdown)="startSpin(data, -1, false)"
                                      (pointerup)="stopSpin()"
                                      (pointerleave)="stopSpin()">▼</button>
                            </div>
                          </div>
                          <div *ngSwitchCase="'int'" class="number-input-wrapper">
                            <input
                              class="form-control titelfont"
                              [formControlName]="data.fieldName"
                              appMinmax
                              [id]="data.fieldName"
                              type="number"
                              inputmode="decimal"
                              [min]="data.min !== undefined ? data.min : 0"
                              [max]="data.max !== undefined ? data.max : ''"
                              [value]="data?.value"
                              [placeholder]="data?.placeholder ? data?.placeholder : ''"
                            />
                            <div class="spinner-buttons">
                              <button type="button" class="spin-btn spin-up"
                                      (click)="stepValue(data, 1, true)"
                                      [ngStyle]="{display: isFormDisabled(data.fieldID ?? data.fieldName) ? 'none' : undefined}"
                                      (pointerdown)="startSpin(data, 1, true)"
                                      (pointerup)="stopSpin()"
                                      (pointerleave)="stopSpin()">▲</button>
                              <button type="button" class="spin-btn spin-down"
                                      (click)="stepValue(data, -1, true)"
                                      [ngStyle]="{display: isFormDisabled(data.fieldID ?? data.fieldName) ? 'none' : undefined}"
                                      (pointerdown)="startSpin(data, -1, true)"
                                      (pointerup)="stopSpin()"
                                      (pointerleave)="stopSpin()">▼</button>
                            </div>
                          </div>
                          <input
                            *ngSwitchCase="'checkbox'"
                            class="form-check-input titelfont"
                            [formControlName]="data.fieldName"
                            [id]="data.fieldName"
                            type="checkbox"
                            [checked]="data?.value"
                          />

                          <textarea
                            *ngSwitchCase="'textarea'"
                            class="form-control"
                            [formControlName]="data.fieldName"
                            [id]="data.fieldName"
                            type="text"
                            [value]="data?.value"
                            cols="2"
                            rows="2"
                          ></textarea>

                          <mat-select
                            class="form-control"
                            *ngSwitchCase="'select'"
                            [(ngModel)]="data.value"
                            [formControlName]="data.fieldName"
                          >
                            <ng-container *ngFor="let list of data.options">
                              <mat-option
                                [value]="list.id"
                                *ngIf="list.id != ''"
                              >
                                {{ list.description }}
                              </mat-option>
                            </ng-container>
                          </mat-select>

                          <input
                            *ngSwitchCase="'text'"
                            class="form-control"
                            [formControlName]="data.fieldName"
                            [id]="data.fieldName"
                            type="text"
                            [value]="data?.value"
                          />

                          <!-- Photo -->
                          <ng-container *ngSwitchCase="'photo'" >
                            <ng-container *ngIf="fieldVisibility(data)">
                              <ng-container *ngTemplateOutlet="photoInput; context: { $implicit: data }"></ng-container>
                            </ng-container>
                          </ng-container>
                        </ng-container>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
              <br />
            </form>
          </ng-container>
          <ng-container *ngIf="!isD">
            <ng-container *ngTemplateOutlet="attachmentdiv"></ng-container>
          </ng-container>
          <ng-container *ngIf="selectedOption == 'instructions'">
            <div class="row mt-3" *ngFor="let item of instructionsItems">
              <label [ngClass]="getClass(layoutValues[0])" class="instLabel">{{
                item?.fieldDescription
              }}</label>
              <label
                [ngClass]="getClass(layoutValues[1])"
                class="instLabel"
                *ngIf="item.fieldType == 'checkbox' && item?.value == null"
                ><input class="form-check-input" type="checkbox" disabled
              /></label>
              <label
                [ngClass]="getClass(layoutValues[0])"
                  class="instLabel"
                  *ngIf="item.fieldType == 'text' && item?.value == null"
                ></label>
                <label
                  class="col-sm-4 instLabel"
                  *ngIf="item.fieldType == 'checkbox' && item?.value != null"
                  ><input
                    class="form-check-input"
                    type="checkbox"
                    checked
                    disabled
                /></label>
                <label
                [ngClass]="[getClass(layoutValues[1]), item.highlight ? 'highlighted' : '']"
                  class="instLabel value-container"
                  *ngIf="item.fieldType == 'text' && item?.value != null"
                  >{{ item?.value }}</label
                >
              </div>
        
            
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #suncircle let-modal>
    <div class="instructions-popup" *ngIf="instructionsSidebar">
     <div class="modal-header">
      <div
        class="d-flex align-items-center justify-content-between"
        style="width: 100%"
      >
        <h2 class="modal-title" style="color: #24597a">
          {{ "HOME.INSTRUCTDOCUMENT" | translate }}
        </h2>
         <div class="header-actions">
          <button
            type="button"
            class="btn prints-btn"
            *ngIf="customizing?.triggerPrint != null"
          (click)="printOptinal('0')" 
          >
            {{ "HOME.PRINTBUTTON" | translate }} 
          </button>
          <button
          #submitButton
          *ngIf="selectedOption == 'checklist'"
            type="button"
            class="btn print-btn"
            (click)="
              addChecklist('',submitButton, true);
              "
          >
            {{ "HOME.SAVEANDCLOSE" | translate }}
          </button>
          <button
          *ngIf="selectedOption !== 'checklist'"
            type="button"
            class="btn print-btn"
            (click)=" modal.dismiss('Cross click')"
          >
            {{ "HOME.CLOSEBUTTON" | translate }} 
          </button>
          <ng-container
            [ngTemplateOutlet]="closeiconbutton" 
            [ngTemplateOutletContext]="{ modal: modal }" 
          ></ng-container>
        </div>
      </div>
       
    </div>
    <div class="modal-body" *ngIf="instructionsSidebar">
      <div class="instructions-content">
        <div class="instructions-content-left" >
          <ul>
            <li>
              <a class="checklisinstruction" [ngClass]="{
                  'chacive bold': Werkbon==false && (selectedOption == 'instructions' || selectedOption == '')
                }" (click)="Werkbon=false; selectedOption=''; instructionsItems ? '':setOption('instructions', '')"> Werkbon </a>
            </li>
            <li *ngIf="checkListItems && checkListItems.length > 0">
              <a
                [ngClass]="{ 'chacive bold': selectedOption == 'checklist' }"
                class="checklisinstruction"
                (click)="setOption('checklist', ''); Werkbon=true;"
                >{{ "HOME.CHECKLIST_LABEL" | translate }}</a
              >
            </li>
            <li *ngFor="let items of attachments">
              <a
                  [ngClass]="{
                    'chacive bold': selectedOption == items?.document_type
                  }"
                  class="checklisinstruction"
                 (click)="setDocument(items?.document_type, items); Werkbon=true"
                >
                  {{ items?.document_type ? items?.document_type : 'Document' }}  
              </a>
            </li>
          </ul>
        </div>
        <div class="projectbody instructions-content-right-desktop" [ngClass]="{'werkbon-document-view': !Werkbon && (selectedOption == 'instructions' || selectedOption == '')}">
          <ng-container *ngIf="selectedOption == 'checklist'">
            <ng-container 
              [ngTemplateOutlet]="checklistInputForm" 
              [ngTemplateOutletContext]="{ $implicit: checkListItems, condition: true }" >
            </ng-container>
          </ng-container>
          <ng-container *ngIf="!Werkbon && (selectedOption == 'instructions' || selectedOption == '')">
      <div class="d-flex justify-content-between mb-2" style="width: 100%">
        <!-- <h2 class="modal-title" style="color: #24597a">
        {{ "HOME.INSTRUCTDOCUMENT" | translate }}
      </h2> -->
        <!-- <div class="row"> -->
        <div class="w-50 d-flex flex-column">
          <label for="" *ngIf="instructionsItems?.prodOrderNo">
            <strong>Prod.-ordernr:</strong>
            {{ instructionsItems?.prodOrderNo }}</label
          >
          <label
            for=""
            *ngIf="instructionsItems?.customerInfo?.Sell_to_Customer_Name"
          >
            <strong>Klantnaam:</strong>
            {{ instructionsItems?.customerInfo?.Sell_to_Customer_Name }}</label
          >
          <label for="" *ngIf="instructionsItems?.dueDate">
            <strong>Verzenddag:</strong> {{ instructionsItems?.dueDate }}</label
          >

          <div *ngIf="instructionsItems?.status == 'Finished'">
            <span class="warning order_button"> Order is reeds verwerkt!</span>
          </div>
        </div>
        <div class="w-50 d-flex flex-column">
          <label
            for=""
            *ngIf="instructionsItems?.qty && instructionsItems?.qty != ''"
            ><strong>Aantal:</strong> {{ instructionsItems?.qty }}</label
          >
          <label
            for=""
            *ngIf="
              instructionsItems?.location && instructionsItems?.location != ''
            "
          >
            <strong>Locatie doek:</strong>
            {{ instructionsItems?.location }}</label
          >
        </div>
      </div>
  

    <div class="modalcontenoverflow" *ngIf="instructionsItems">
      <div class="modal_padding">
        <div class="d-flex">
          <div class="instruction_first_section">
            <h1 class="title font-weight-qr">
              {{ instructionsItems?.materialDescription }}
            </h1>
          </div>
          <div class="">
            <h1 class="title font-weight-qr">
              {{ instructionsItems?.orderID }}
            </h1>
          </div>
        </div>
        <div [ngClass]="[instructionsItems?.QRcode ? 'd-flex gap-2 ' : '']">
          <div
            [ngClass]="[
              instructionsItems?.QRcode ? 'colum_list2' : 'colum_list3'
            ]"
          >
            <div
              class="card_input_block"
              *ngFor="let list of instructionsItems?.articleFeatures?.value"
            >
              <div class="d-flex align-items-center gap-1">
                <div class="w-50">
                  <label for="">{{ list.Name }}</label>
                </div>
                <div class="" [ngStyle]="{
          'background-color': list.highlight ? 'yellow' : ''
        }">
                  <label for=""> {{ list.Value }}</label>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="this.instructionsItems?.QRcode">
            <h6 class="qr_info_details" *ngIf="instructionsItems?.karLocation">
              <span class="font-weight-qr"> Locatie kar : &nbsp;</span>
              <span class="kar-dotted-underline" (click)="openLocatie(spoed)">
                {{ instructionsItems?.karLocation }}</span
              >
            </h6>
            <qrcode
              [qrdata]="this.instructionsItems?.QRcode"
              [width]="300"
              [errorCorrectionLevel]="'M'"
            ></qrcode>
          </div>
        </div>
      </div>

      <div
        class="d-flex flex-column footer_padding"
        *ngFor="let data of instructionsItems?.productionBOM"
      >
        <label *ngIf="data?.Name" for=""
          ><strong>{{ data?.Name }}</strong></label
        >
        <label for="">Materiaal</label>
        <div class="row mb-1">
          <div class="col-12 col-md-6" *ngFor="let list of data?.Value">
            <div class="row align-items-center material-row">
              <div class="col-2 col-md-1 qty">
                <label for="" class="mb-0">
                  {{
                    list.Unit_of_Measure_Code == "M1"
                      ? null
                      : +list?.Quantity_per * +instructionsItems.qty
                  }}
                  &nbsp;&nbsp;
                </label>
              </div>
              <div class="col-7 col-md-8 desc">
                <label for="" class="mb-0 w-100"> {{ list?.Description }} </label>
              </div>
              <div class="col-3 unit">
                <label for="" class="mb-0">
                  {{ 
                    list.Unit_of_Measure_Code === 'M2'
                      ? list?.Length + ' x ' + list?.Width
                      : (list.Unit_of_Measure_Code !== 'MM' && list.Unit_of_Measure_Code !== 'm'
                          ? null
                          : list?.Length)
                  }}
                  {{ list.Unit_of_Measure_Code === 'M2' ? 'm' : list?.Unit_of_Measure_Code }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
          </ng-container>
          <div
            *ngIf="deviceInfo"
            [hidden]="!Werkbon"
            class="werkbon-viewer-container"
            [class.viewer-hidden]="selectedOption === 'checklist'"
          >
            <ng-container *ngIf="this.deviceInfo.deviceType != 'mobile'">
              <div class="loader" *ngIf="isLoading"></div>
              <ng-container *ngIf="currentDocumentType == 'image' && imageUrl">
                <div class="document-image-wrapper">
                  <img [src]="imageUrl" class="document-image" alt="attachment preview" (load)="onImageLoad()" (error)="onImageError()" />
                </div>
              </ng-container>
              <ng-container *ngFor="let viewer of pdfViewers">
                <iframe
                  #pdfViewerFrame
                  [attr.data-pdf-index]="viewer.attachmentIndex"
                  [src]="viewer.viewerUrl"
                  [hidden]="
                    viewer.attachmentIndex !== activePdfAttachmentIndex ||
                    selectedOption === 'checklist' ||
                    currentDocumentType !== 'pdf'
                  "
                  class="pdf-viewer-frame"
                  title="PDF attachment preview"
                  frameborder="0"
                  (load)="onPdfViewerLoad(viewer)"
                ></iframe>
              </ng-container>
              <!-- <ng-container *ngIf="blobPdf">
                <iframe
                  (load)="loadingPDF()"
                  [src]="pdfViewerUrl"
                  width="100%"
                  height="70vh"
                  style="border: none;"
                ></iframe> -->

            <!-- <pdf-viewer
                  [src]="src"
                  [render-text]="true"
                  style="display: block; height: 100%;"
                  [autoresize]="true"
                  [original-size]="false">
                </pdf-viewer> -->
              <!-- </ng-container> -->
            </ng-container>
            <ng-container *ngIf="this.deviceInfo.deviceType == 'mobile'">
              <!-- <ngx-extended-pdf-viewer [src]="src" [useBrowserLocale]="true">
                
              </ngx-extended-pdf-viewer> -->
              <div class="loader" *ngIf="isLoading"></div>
              <!-- <iframe
              (load)="loadingPDF()"
              *ngIf="src"
              [src]="src"
              class="iframe"
              frameborder="0"
              ></iframe> -->
              <div class="error-message" style="display: none">
                Unable to load the requested content. Please try again later.
              </div>
              <ng-container *ngIf="currentDocumentType != 'image' && blobPdf">
                <iframe
                  [src]="pdfViewerUrl"
                  width="100%"
                  height="70vh"
                  style="border: none;"
                ></iframe>

              <!-- <pdf-viewer
              [src]="src"
              [render-text]="true"
              style="display: block;"
              [autoresize]="true"
              [original-size]="false">
            </pdf-viewer> -->
          </ng-container>
          <ng-container *ngIf="currentDocumentType == 'image' && imageUrl">
                <div class="document-image-wrapper">
                  <img [src]="imageUrl" class="document-image" alt="attachment preview" (load)="onImageLoad()" (error)="onImageError()" />
                </div>
              </ng-container>
            <ng-container *ngIf="currentDocumentType != 'image' && !blobPdf">
                <iframe class="iframeTou" frameborder="0"></iframe>
              </ng-container>
            </ng-container>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div  class="instructions-popup" *ngIf="attachments?.length == 0 || attachments?.length == null || !instructionsSidebar">
    <div class="modal-header align-items-start  ">
      <div
      class="d-flex  justify-content-between"
      style="width: 100%"
    >
      <!-- <h2 class="modal-title" style="color: #24597a">
        {{ "HOME.INSTRUCTDOCUMENT" | translate }}
      </h2> -->
      <!-- <div class="row"> -->
        <div class="w-50 d-flex flex-column ">
<label for="" *ngIf="instructionsItems?.prodOrderNo"> <strong>Prod.-ordernr:</strong> {{instructionsItems?.prodOrderNo}}</label>
<label for="" *ngIf="instructionsItems?.customerInfo?.Sell_to_Customer_Name"> <strong>Klantnaam:</strong> {{instructionsItems?.customerInfo?.Sell_to_Customer_Name}}</label>
<label for="" *ngIf="instructionsItems?.dueDate"> <strong>Verzenddag:</strong> {{instructionsItems?.dueDate}}</label>

<div *ngIf="instructionsItems?.status == 'Finished'">
<span class="warning order_button" > Order is reeds verwerkt!</span>
</div>
        </div>
        <div class="w-50 d-flex flex-column ">
<label for="" *ngIf="instructionsItems?.qty && instructionsItems?.qty !=''"><strong>Aantal:</strong> {{instructionsItems?.qty}}</label>
<label for="" *ngIf="instructionsItems?.location && instructionsItems?.location !=''"> <strong>Locatie doek:</strong> {{instructionsItems?.location}}</label>
        </div>

      <!-- </div> -->
    </div>
      <div class="header-actions">
      <button
      type="button"
      class="btn prints-btn"
      (click)="printOptinal('0')" 
    >
      {{ "HOME.PRINTBUTTON" | translate }}
    </button>
        <button
          type="button"
          class="btn back-btn gray-light "
          (click)="modal.dismiss('Cross clicked')"
        >
        {{ "HOME.CLOSEBUTTON" | translate }}
        </button>
      </div>
    </div>
    <div class="modalcontenoverflow 88888" *ngIf="instructionsItems">
      <div class=" modal_padding">
        <div class="d-flex">
          <div class="instruction_first_section">
             <h1 class="title font-weight-qr ">{{instructionsItems?.materialDescription}}</h1>
          </div>
          <div class="">
             <h1 class="title font-weight-qr ">{{instructionsItems?.orderID}}</h1>
          </div>
        </div>
        <div  [ngClass]="[ instructionsItems?.QRcode ?'d-flex gap-2 ':'']"  >  
        <div [ngClass]="[ instructionsItems?.QRcode ?'colum_list2':'colum_list3']">
          <div class="card_input_block" *ngFor="let list of instructionsItems?.articleFeatures?.value">
            <div class="d-flex align-items-center gap-1 " >
              <div class="w-50">
                <label for="">{{list.Name}}</label>
              </div>
              <div class=""  [ngStyle]="{
          'background-color': list.highlight ? 'yellow' : ''
        }">
                <label for=""> {{list.Value}}</label>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="this.instructionsItems?.QRcode">
          <h6 class="qr_info_details" *ngIf="instructionsItems?.karLocation"><span class="font-weight-qr "> Locatie kar : &nbsp;</span> <span class="kar-dotted-underline" (click)="openLocatie(spoed)">{{instructionsItems?.karLocation}}</span></h6>
          <qrcode [qrdata]="this.instructionsItems?.QRcode" [width]="300" [errorCorrectionLevel]="'M'"></qrcode>
        </div>
      </div>
    </div>
  
    <div class="d-flex flex-column footer_padding " *ngFor="let data of instructionsItems?.productionBOM">
      <label *ngIf="data?.Name" for=""><strong>{{data?.Name}}</strong></label>
        <label for="">Materiaal</label>
        <div class="row mb-1">
          <div class="col-12 col-md-6" *ngFor="let list of data?.Value">
            <div class="row align-items-center material-row">
              <div class="col-2 col-md-1 qty">
                <label class="mb-0" for=""> {{(list.Unit_of_Measure_Code == 'M1') ? null : (+list?.Quantity_per )*(+instructionsItems.qty) }} &nbsp;&nbsp; </label>
  
              </div>
              <div class="col-7 col-md-8 desc">
                <label class="mb-0 w-100 " for=""> {{list?.Description}} </label>
  
              </div>
              <div class="col-3 unit">
                <label for="" class="mb-0">
                  {{
                    list.Unit_of_Measure_Code === 'M2'
                      ? list?.Length + ' x ' + list?.Width
                      : (list.Unit_of_Measure_Code !== 'MM' && list.Unit_of_Measure_Code !== 'm'
                          ? null
                          : list?.Length)
                  }}
                  {{ list.Unit_of_Measure_Code === 'M2' ? 'm' : list?.Unit_of_Measure_Code }}
                </label>
              </div>
  
            </div>
            
          </div>
        </div>
      </div>
    </div>
    <div class="loader" *ngIf="!instructionsItems && selectedOption != 'checklist'"></div>
  </div>
</ng-template>
<ng-template #checklist let-modal>
  <div class="instructions-popup">
    <div class="modal-header">
      <div
        class="d-flex align-items-center justify-content-between"
        style="width: 100%"
      >
        <h2 class="modal-title" style="color: #24597a">
          {{ "HOME.INSTRUCTDOCUMENT" | translate }}
        </h2>
        <div class="">
          <div class="header-actions" [ngClass]="[autosave === 1 && saveMessage !== null ? 'align-items-start mb-1':'']">
            <button
          type="button"
            *ngIf="customizing?.triggerPrint != null"
            class="btn prints-btn"
            (click)="postPrintDetails('0', false)"
          >
            {{ "HOME.PRINTBUTTON" | translate }}
          </button>
          <!-- [disabled]="+customizing?.allow_cancelChecklist === 0" -->
          <ng-container *ngIf="approverInfo">
            <ng-container [ngTemplateOutlet]="userDropdown" [ngTemplateOutletContext]="{ showNfc: selectedOption == 'checklist' }" ></ng-container>
          </ng-container>
          <div class="header-save-buttons">
          <div class="header-actions">
           <!-- <button
           #submitButton
            type="button"
            class="btn blue-btn"
            (click)="addChecklist('',submitButton, false)"
            [disabled]="autosave === 1 && isSaveButtonDisabled"
            >
            {{ "HOME.SAVE" | translate }}
          </button> -->
          
          <button
          #submitButton
          *ngIf="selectedOption == 'checklist'"
            type="button"
            class="btn print-btn"
            [disabled]="autosave === 1 && isSaveButtonDisabled"
            (click)="
              addChecklist('',submitButton, true);
              "
          >
            {{ "HOME.SAVEANDCLOSE" | translate }}
          </button>
          <button
          *ngIf="selectedOption !== 'checklist'"
            type="button"
            class="btn print-btn"
            (click)="modal.dismiss('Cross click')"
          >
            {{ "HOME.CLOSEBUTTON" | translate }}
          </button>
        </div>
          <ng-container *ngIf="saveMessage !== null">
            <div class="autosave-text" *ngIf="saveMessage">
              {{"HOME.AUTOSAVESUCCESS" | translate}}
            </div>
            <div class="autosave-text" *ngIf="!saveMessage">
              {{"HOME.AUTOSAVEFAIL" | translate}}
            </div>
          </ng-container>
        </div>
        <ng-container
            [ngTemplateOutlet]="closeiconbutton" 
            [ngTemplateOutletContext]="{ modal: modal }" 
          ></ng-container>
        </div>
        <ng-container *ngIf="displayConcurrencyMessage && conurrentUsers && conurrentUsers.length > 0">
          <div class="concurrent-user-text" >
            {{"HOME.CONCURRENTUSERTEXT" | translate}} {{conurrentUsers.join(', ')}}.
          </div>
        </ng-container>
      </div>
      </div>
    </div>
    <div class="modal-body">
      <div class="instructions-content" >
        <div class="instructions-content-left">
          <ul>
            <!-- <li
              *ngIf="customizing?.showInstructions != null || (customizing?.showInstructions == goodsRecipt || goodsRecipt == '')">
              <a [ngClass]="{
                bold: selectedOption == 'instructions'
              }" (click)="setOption('instructions','')" *ngIf="showInstructions">{{ "HOME.INSTRUCTIONS_LABEL" |
                translate }}</a>
            </li> -->
            <li
              *ngIf="
                customizing?.showInstructions != null ||
                customizing?.showInstructions == goodsRecipt ||
                goodsRecipt == '' ||
                true
              "
            >
              <a
                [ngClass]="selectedOption == 'instructions' ? 'chacive bold' : ''"
                class="checklisinstruction "
                (click)="
                  setOption('instructions', '');
                  diactivatedFlag = false;
                  isD = true;
                  inputText = ''
                "
                >{{ "HOME.INSTRUCTIONS_LABEL" | translate }}</a
              >
            </li>
            <li>
              <a
                [ngClass]="{
                  'chacive bold': selectedOption == 'checklist'
                }"
                class="checklisinstruction"
                (click)="setOption('checklist', ''); isD = true"
                >{{ "HOME.CHECKLIST_LABEL" | translate }}</a
              >
            </li>
            <ng-container *ngIf="!this.pdfFlag">
              <li *ngFor="let items of attachments">
                <a
                  class="checklisinstruction"
                  [ngClass]="{
                    'chacive bold': selectedOption == items?.document_type
                  }"
                  (click)="setOption(items?.document_type, items);isD = false"
                  >{{ items?.document_type }}</a
                >
              </li>
            </ng-container>
          </ul>
        </div>
        <!-- <ng-container *ngIf="isD"> -->
          <div class="projectbody instructions-content-right-desktop"> 
           <ng-container 
             [ngTemplateOutlet]="checklistInputForm" 
             [ngTemplateOutletContext]="{ $implicit: checklistItemss, condition: selectedOption == 'checklist' }" >
           </ng-container>
         
           <ng-container *ngIf="!isD">
            <ng-container *ngTemplateOutlet="attachmentdiv"></ng-container>
          </ng-container>

          <ng-container *ngIf="selectedOption == 'instructions'">
            <div class="row mt-3" *ngFor="let item of instructionsItems">
              <label [ngClass]="getClass(layoutValues[0])" class="instLabel">{{
                item?.fieldDescription
              }}</label>
              <label
                [ngClass]="getClass(layoutValues[1])"
                class="instLabel"
                *ngIf="item.fieldType == 'checkbox' && item?.value == null"
                ><input class="form-check-input" type="checkbox" disabled
              /></label>
              <label
                [ngClass]="getClass(layoutValues[0])"
                  class="instLabel"
                  *ngIf="item.fieldType == 'text' && item?.value == null"
                ></label>
                <label
                  class="col-sm-4 instLabel"
                  *ngIf="item.fieldType == 'checkbox' && item?.value != null"
                  ><input
                    class="form-check-input"
                    type="checkbox"
                    checked
                    disabled
                /></label>
                <label
                [ngClass]="[getClass(layoutValues[1]), item.highlight ? 'highlighted' : '']"
                  class="instLabel value-container"
                  *ngIf="item.fieldType == 'text' && item?.value != null"
                  >{{ item?.value }}</label
                >
              </div>
          </ng-container>
        </div> 
      </div>
    </div>
  </div>
</ng-template>
<ng-template #checklisttop let-modal>
  <div class="instructions-popup">
    <div class="modal-header">
      <div
        class="d-flex align-items-center justify-content-between"
        style="width: 100%"
      >
        <h2 class="modal-title" style="color: #24597a">
          {{ "HOME.INSTRUCTDOCUMENT" | translate }}
        </h2>
        <div class="header-actions">
          <button
            type="button"
            *ngIf="customizing?.triggerPrint != null"
            class="btn prints-btn"
            (click)="postPrintDetails('0', false)"
          >
            {{ "HOME.PRINTBUTTON" | translate }}
          </button>
          <ng-container *ngIf="approverInfo">
              <ng-container [ngTemplateOutlet]="userDropdown" [ngTemplateOutletContext]="{ showNfc: selectedOption == 'checklist' }"></ng-container>
           </ng-container>
          <!-- [disabled]="+customizing?.allow_cancelChecklist === 0" -->
          <!-- <button
            type="button"
            #submitButton
            class="btn blue-btn"
            (click)="aaddChecklist('',submitButton, false)"
          >
            {{ "HOME.SAVE" | translate }}
          </button> -->
          <button
            *ngIf="
              (!isShow || this.attachments?.length == 0 || !this.attachments) && selectedOption == 'checklist'
            "
            type="button"
            class="btn print-btn"
            #submitButton
            (click)="aaddChecklist('',submitButton, true); modal.dismiss('Cross clicked')"
          >
            {{ "HOME.SAVEANDCLOSE" | translate }}
          </button>
          <button
            *ngIf="isShow && this.attachments && this.attachments.length > 0 || selectedOption != 'checklist'"
            type="button"
            class="btn print-btn"
            (click)="modal.dismiss('Cross clicked')"
          >
            {{ "HOME.CLOSEBUTTON" | translate }}
          </button>
          <ng-container
            [ngTemplateOutlet]="closeiconbutton" 
            [ngTemplateOutletContext]="{ modal: modal }" 
          ></ng-container>
        </div>
      </div>
    </div>
    <div class="modal-body">
      <div class="instructions-content" >
        <div class="instructions-content-left">
          <ul>
            <!-- <li
              *ngIf="customizing?.showInstructions != null || (customizing?.showInstructions == goodsRecipt || goodsRecipt == '')">
              <a [ngClass]="{
                bold: selectedOption == 'instructions'
              }" (click)="setOption('instructions','')" *ngIf="showInstructions">{{ "HOME.INSTRUCTIONS_LABEL" |
                translate }}</a>
            </li> -->

            <li>
              <a
                [ngClass]="{
                  'chacive bold': selectedOption == 'checklist'
                }"
                class="checklisinstruction"
                (click)="setOption('checklist', '')"
                >{{ "HOME.CHECKLIST_LABEL" | translate }}</a
                >
            </li>
            <ng-container *ngIf="!this.pdfFlag">
              <li *ngFor="let items of attachments">
                <a
                  [ngClass]="{
                    'chacive bold': selectedOption == items?.document_type
                  }"
                  class="checklisinstruction "
                  (click)="setOption(items?.document_type, items)"
                  >{{ items?.document_type }}</a
                >
              </li>
            </ng-container>
          </ul>
        </div>
        <div class="projectbody instructions-content-right-desktop">
          <ng-container>
            <form
              novalidate
              [formGroup]="checklistFormList"
            >
              <ng-container 
                [ngTemplateOutlet]="simpleformfields" 
                [ngTemplateOutletContext]="{ $implicit: check_List }">
              </ng-container>
              <br />
            </form>
          </ng-container>

          <ng-container>
            <ng-container *ngTemplateOutlet="attachmentdiv"></ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #onlyChecklist let-modal>
  <div class="instructions-popup">
    <div class="modal-header">
      <div
        class="d-flex align-items-center justify-content-between"
        style="width: 100%"
      >
        <h2 class="modal-title" style="color: #24597a">
          {{ "HOME.INSTRUCTDOCUMENT" | translate }}
        </h2>
        <div class="header-actions">
          <button
            type="button"
            *ngIf="customizing?.triggerPrint != null"
            class="btn prints-btn"
            (click)="postPrintDetails('0', false)"
          >
            {{ "HOME.PRINTBUTTON" | translate }}
          </button>
          <ng-container *ngIf="approverInfo">
              <ng-container [ngTemplateOutlet]="userDropdown" [ngTemplateOutletContext]="{ showNfc: selectedOption == 'checklist' || isD}"></ng-container>
           </ng-container>
          <!-- [disabled]="+customizing?.allow_cancelChecklist === 0" -->
          <!-- <button
            type="button"
            class="btn blue-btn"
            (click)="addChecklist('',submitButton, false)"
          >
            {{ "HOME.SAVE" | translate }}
          </button> -->
          <button
            *ngIf="isD"
            type="button"
            class="btn print-btn"
            #submitButton
            (click)="addChecklist('',submitButton, true); modal.dismiss('Cross click')"
          >
            {{ "HOME.SAVEANDCLOSE" | translate }}
          </button>
          <button
            *ngIf="!isD"
            type="button"
            class="btn print-btn"
            (click)="modal.dismiss('Cross click')"
          >
            {{ "HOME.CLOSEBUTTON" | translate }}
          </button>
          <ng-container
            [ngTemplateOutlet]="closeiconbutton" 
            [ngTemplateOutletContext]="{ modal: modal }" 
          ></ng-container>
        </div>
      </div>
    </div>

    <div class="modal-body">
      <div class="instructions-content">
        <div class="instructions-content-left">
          <ul>
            <li>
              <a [ngClass]="{'chacive bold': selectedOption == 'checklist' || isD}" class="checklisinstruction" (click)="setOption('checklist', '')">{{
                "HOME.CHECKLIST_LABEL" | translate
              }}</a>
            </li>
            <ng-container *ngIf="!this.pdfFlag">
              <li *ngFor="let items of attachments">
                <a
                  [ngClass]="{
                    'chacive bold': selectedOption == items?.document_type
                  }"
                  class="checklisinstruction"
                  (click)="setOption(items?.document_type, items); isD = false"
                  >{{ items?.document_type }}</a
                >
              </li>
            </ng-container>
          </ul>
        </div>
        <div class="projectbody instructions-content-right-desktop">
          <ng-container 
            [ngTemplateOutlet]="checklistInputForm" 
            [ngTemplateOutletContext]="{ $implicit: checklistItemss, condition: true }" >
          </ng-container>

          <ng-container *ngIf="!isD">
            <ng-container *ngTemplateOutlet="attachmentdiv"></ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #instructions let-modal>
  <div class="instructions-popup">
    <div class="modal-header">
      <div
        class="d-flex align-items-center justify-content-between"
        style="width: 100%"
      >
        <h2 class="modal-title" style="color: #24597a">
          {{ "HOME.INSTRUCTDOCUMENT" | translate }}
        </h2>
        <div class="header-actions">
          <button
            type="button"
            *ngIf="customizing?.triggerPrint != null"
            class="btn prints-btn"
            (click)="postPrintDetails('0', false)"
          >
            {{ "HOME.PRINTBUTTON" | translate }}
          </button>
          <!-- <ng-container *ngIf="approverInfo">
              <ng-container *ngTemplateOutlet="userDropdown"></ng-container>
           </ng-container> -->
          <!-- [disabled]="+customizing?.allow_cancelChecklist === 0" -->
          <!-- <button
            type="button"
            class="btn blue-btn"
            (click)="addChecklist('',submitButton, false)"
          >
            {{ "HOME.SAVE" | translate }}
          </button> -->
          <button
            type="button"
            class="btn print-btn"
            (click)="modal.dismiss('Cross click')"
          >
            {{ "HOME.CLOSEBUTTON" | translate }}
          </button>
          <ng-container
            [ngTemplateOutlet]="closeiconbutton" 
            [ngTemplateOutletContext]="{ modal: modal }" 
          ></ng-container>
        </div>
      </div>
    </div>
    <div class="modal-body">
      <div class="instructions-content">
        <div class="instructions-content-left">
          <ul>
            <li
              *ngIf="
                customizing?.showInstructions != null ||
                customizing?.showInstructions == goodsRecipt ||
                goodsRecipt == ''
              "
            >
              <a
                [ngClass]="{
                  'chacive bold': true
                }"
                class="checklisinstruction"
                (click)="setOption('instructions', '')"
                >{{ "HOME.INSTRUCTIONS_LABEL" | translate }}</a
              >
            </li>
            <ng-container *ngIf="!this.pdfFlag">
              <li *ngFor="let items of attachments">
                <a
                  class="checklisinstruction"
                  [ngClass]="{
                    'chacive bold': selectedOption == items?.document_type
                  }"
                  (click)="setOption(items?.document_type, items)"
                  >{{ items?.document_type }}</a
                >
              </li>
            </ng-container>
          </ul>
        </div>
        <div class="projectbody instructions-content-right-desktop">
          <div class="row mt-3" *ngFor="let item of instructionsItems">
            <label [ngClass]="getClass(layoutValues[0])" class="instLabel">{{
              item?.fieldDescription
            }}</label>
            <label
              [ngClass]="getClass(layoutValues[1])"
              class="instLabel"
              *ngIf="item.fieldType == 'checkbox' && item?.value == null"
              ><input class="form-check-input" type="checkbox" disabled
            /></label>
            <label
              [ngClass]="getClass(layoutValues[0])"
                class=" instLabel"
                *ngIf="item.fieldType == 'text' && item?.value == null"
              ></label>
              <label
                class="col-sm-4 instLabel"
                *ngIf="item.fieldType == 'checkbox' && item?.value != null"
                ><input
                  class="form-check-input"
                  type="checkbox"
                  checked
                  disabled
              /></label>
              <label  [ngClass]="[getClass(layoutValues[1]), item.highlight ? 'highlighted' : '']"
                class=" instLabel value-container"
                *ngIf="item.fieldType == 'text' && item?.value != null"
                >{{ item?.value }}</label
              >
            </div>
            
          <ng-container *ngTemplateOutlet="attachmentdiv"></ng-container>

        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #checklistinstructions let-modal>
  <div class="instructions-popup">
    <div class="modal-header" >
      <div
        class="d-flex align-items-center justify-content-between"
        style="width: 100%"
      >
        <h2 class="modal-title" style="color: #24597a">
          {{ "HOME.INSTRUCTDOCUMENT" | translate }}
        </h2>
        <div class="header-actions">
          <button
            type="button"
            *ngIf="customizing?.triggerPrint != null"
            class="btn prints-btn"
            (click)="postPrintDetails('0', false)"
          >
            {{ "HOME.PRINTBUTTON" | translate }}
          </button>
          <ng-container *ngIf="approverInfo">
              <ng-container [ngTemplateOutlet]="userDropdown" [ngTemplateOutletContext]="{ showNfc: !isShow}"></ng-container>
           </ng-container>
          <!-- [disabled]="+customizing?.allow_cancelChecklist === 0" -->
          <!-- <button
            type="button"
            class="btn blue-btn"
            (click)="addChecklist('',submitButton, false)"
          >
            {{ "HOME.SAVE" | translate }}
          </button> -->
          <button
            *ngIf="isShow"
            type="button"
            class="btn print-btn"
            [ngClass]="{ 'disabled-btn disabled': isShow }"
            #submitButton
            (click)="addChecklist('',submitButton, true); modal.dismiss('Cross click')"
          >
            {{ "HOME.SAVEANDCLOSE" | translate }}
          </button>
          <button
            *ngIf="!isShow"
            type="button"
            class="btn print-btn"
            (click)="modal.dismiss('Cross click')"
          >
            {{ "HOME.CLOSEBUTTON" | translate }}
          </button>
          <ng-container
            [ngTemplateOutlet]="closeiconbutton" 
            [ngTemplateOutletContext]="{ modal: modal }" 
          ></ng-container>

        </div>
      </div>
    </div>
    <div class="modal-body">
      <div class="instructions-content">
        <div class="instructions-content-left">
          <ul>
            <li
              *ngIf="
                customizing?.showInstructions != null ||
                customizing?.showInstructions == goodsRecipt ||
                goodsRecipt == ''
              "
            >
              <a
                [ngClass]="isShow ? 'chacive bold' : ''"
                class="checklisinstruction"
                (click)="setOption('instructions', ''); isShow = true"
                >{{ "HOME.INSTRUCTIONS_LABEL" | translate }}</a
              >
            </li>
            <li>
              <a
                class="checklisinstruction"
                [ngClass]="!isShow ? 'chacive bold' : ''"
                (click)="
                  setOption('checklist', '');
                  isShow = false;
                  this.secondOrderId = ''
                  "
                >{{ "HOME.CHECKLIST_LABEL" | translate }}</a
                >
            </li>
            
            <ng-container *ngIf="!this.pdfFlag">
              <li *ngFor="let items of attachments">
                <a
                  class="checklisinstruction"
                  [ngClass]="{
                    'chacive bold': selectedOption == items?.document_type
                  }"
                  (click)="setOption(items?.document_type, items); isD = false"
                  >{{ items?.document_type }}</a
                >
              </li>
            </ng-container>
          </ul>
        </div>
        <div *ngIf="!isShow" class="projectbody instructions-content-right-desktop" >
          <ng-container 
            [ngTemplateOutlet]="checklistInputForm" 
            [ngTemplateOutletContext]="{ $implicit: checklistItemss, condition: isD }" >
          </ng-container>

          <ng-container *ngIf="!isD">
            <ng-container *ngTemplateOutlet="attachmentdiv"></ng-container>
          </ng-container>
        </div>
        <div
          *ngIf="isShow"
          class="projectbody instructions-content-right-desktop"
        >
          <div class="row mt-3" *ngFor="let item of instructionsItems">
            <label [ngClass]="getClass(layoutValues[0])" class="instLabel">{{
              item?.fieldDescription
            }}</label>
            <label
              [ngClass]="getClass(layoutValues[1])"
              class="instLabel"
              *ngIf="item.fieldType == 'checkbox' && item?.value == null"
              ><input class="form-check-input" type="checkbox" disabled
            /></label>
            <label
              [ngClass]="getClass(layoutValues[0])"
                class=" instLabel"
                *ngIf="item.fieldType == 'text' && item?.value == null"
              ></label>
              <label
                class="col-sm-4 instLabel"
                *ngIf="item.fieldType == 'checkbox' && item?.value != null"
                ><input
                  class="form-check-input"
                  type="checkbox"
                  checked
                  disabled
              /></label>
              <label
              [ngClass]="[getClass(layoutValues[1]), item.highlight ? 'highlighted' : '']"
                class="instLabel value-container"
                *ngIf="item.fieldType == 'text' && item?.value != null"
                >{{ item?.value }}</label
              >
            </div>
            
          
          <ng-container *ngTemplateOutlet="attachmentdiv"></ng-container>

        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #topinstructionchecklist let-modal>
  <div class="instructions-popup" style="overflow: auto">
    <div class="modal-header">
      <div
        class="d-flex align-items-center justify-content-between"
        style="width: 100%"
      >
        <h2 class="modal-title" style="color: #24597a">
          {{ "HOME.INSTRUCTDOCUMENT" | translate }}
        </h2>
        <div class="header-actions">
          <button
            type="button"
            *ngIf="customizing?.triggerPrint != null"
            class="btn prints-btn"
            (click)="postPrintDetails('0', false)"
          >
            {{ "HOME.PRINTBUTTON" | translate }}
          </button>
          <button
            [disabled]="+customizing?.allow_cancelChecklist === 0"
            type="button"
            class="btn back-btn"
            (click)="modal.dismiss('Cross click'); resetForm()"
          >
            {{ "HOME.CANCELBUTTON" | translate }}
          </button>
          <ng-container
            [ngTemplateOutlet]="closeiconbutton" 
            [ngTemplateOutletContext]="{ modal: modal }" 
          ></ng-container>
        </div>
      </div>
    </div>

    <div class="modal-body">
      <div class="instructions-content justify-content-between">
        <div
          class="instructions-content-left instructions-content-right-desktop-deep"
        >
          <ul>
            <li
              *ngIf="
                customizing?.showInstructions != null ||
                customizing?.showInstructions == goodsRecipt ||
                goodsRecipt == ''
              "
            >
              <a
                [ngClass]="{
                  'chacive bold': selectedOption == 'instructions'
                }"
                class="checklisinstruction"
                (click)="setOption('instructions', '')"
                >{{ "HOME.INSTRUCTIONS_LABEL" | translate }}</a
              >
            </li>

            <li *ngFor="let items of attachments">
              <a
                [ngClass]="{
                  'chacive bold': selectedOption == items?.document_type
                }"
                class="checklisinstruction"
                (click)="setOption(items?.document_type, items)"
                >{{ items?.document_type }}</a
              >
            </li>
          </ul>
        </div>
        <div
          class="projectbody instructions-content-right-desktop instructions-content-right-desktop-deep"
        >
          <div class="modal-header modal-header-acn">
            <div
              class="d-flex align-items-center justify-content-between"
              style="width: 100%"
            >
              <h2 class="modal-title" style="color: #24597a"></h2>
              <div class="header-actions">
                <button
                  type="button"
                  class="btn print-btn"
                  [ngClass]="{ 'disabled-btn disabled': true }"
                  #submitButton
                  (click)="addChecklist('',submitButton, true); modal.dismiss('Cross click')"
                >
                  {{ "HOME.SAVEANDCLOSE" | translate }}
                </button>
              </div>
            </div>
          </div>

          <div class="row mt-3" *ngFor="let item of instructionsItems">
            <label [ngClass]="getClass(layoutValues[0])" class="instLabel">{{
              item?.fieldDescription
            }}</label>
            <label
              [ngClass]="getClass(layoutValues[1])"
              class="instLabel"
              *ngIf="item.fieldType == 'checkbox' && item?.value == null"
              ><input class="form-check-input" type="checkbox" disabled
            /></label>
            <label
              [ngClass]="getClass(layoutValues[0])"
                class="instLabel"
                *ngIf="item.fieldType == 'text' && item?.value == null"
              ></label>
              <label
                class="col-sm-4 instLabel"
                *ngIf="item.fieldType == 'checkbox' && item?.value != null"
                ><input
                  class="form-check-input"
                  type="checkbox"
                  checked
                  disabled
              /></label>
              <label
              [ngClass]="[getClass(layoutValues[1]), item.highlight ? 'highlighted' : '']"
                class="instLabel value-container"
                *ngIf="item.fieldType == 'text' && item?.value != null"
                >{{ item?.value }}</label
              >
            </div>
            
          
          <ng-container *ngTemplateOutlet="attachmentdiv"></ng-container>

        </div>
      </div>
    </div>

    <div class="modal-header p-0"></div>
    <div class="modal-body">
      <div class="instructions-content justify-content-between">
        <div
          class="instructions-content-left instructions-content-right-desktop-deep"
        >
          <ul>
            <!-- <li
              *ngIf="customizing?.showInstructions != null || (customizing?.showInstructions == goodsRecipt || goodsRecipt == '')">
              <a [ngClass]="{
                bold: selectedOption == 'instructions'
              }" (click)="setOption('instructions','')" *ngIf="showInstructions">{{ "HOME.INSTRUCTIONS_LABEL" |
                translate }}</a>
            </li> -->
            <li>
              <a
                [ngClass]="{
                  'chacive bold': selectedOption == 'checklist'
                }"
                class="checklisinstruction"
                (click)="setOption('checklist', '')"
                >{{ "HOME.CHECKLIST_LABEL" | translate }}</a
              >
            </li>
            <li *ngFor="let items of attachments">
              <a
                class="checklisinstruction"
                [ngClass]="{
                  'chacive bold': selectedOption == items?.document_type
                }"
                (click)="setOption(items?.document_type, items)"
                >{{ items?.document_type }}</a
              >
            </li>
          </ul>
        </div>
        <div
          class="projectbody instructions-content-right-desktop instructions-content-right-desktop-deep"
        >
          <div class="modal-header modal-header-acn">
            <div
              class="d-flex align-items-center justify-content-end"
              style="width: 100%"
            >
              <!-- <h2 class="modal-title" style="color: #24597A;">{{ "HOME.INSTRUCTDOCUMENT" | translate }}</h2> -->
              <div class="header-actions">
                <!-- <button type="button" *ngIf="customizing?.triggerPrint != null" class="btn prints-btn"
                  (click)="postPrintDetails('0')"> {{ "HOME.PRINTBUTTON" | translate }}</button>
                <button type="button" class="btn back-btn" (click)="modal.dismiss('Cross click');resetForm()"> {{
                  "HOME.CANCELBUTTON" | translate
                  }}</button> -->
                  <ng-container *ngIf="approverInfo">
                      <ng-container [ngTemplateOutlet]="userDropdown" [ngTemplateOutletContext]="{ showNfc: selectedOption == 'checklist'}"></ng-container>
                  </ng-container>
                <!-- <button
                  type="button"
                  class="btn blue-btn"
                  (click)="addChecklist('',submitButton, false)"
                >
                  {{ "HOME.SAVE" | translate }}
                </button> -->
                <button
                  type="button"
                  class="btn print-btn"
                  #submitButton
                  (click)="addChecklist('',submitButton, true); modal.dismiss('Cross click')"
                >
                  {{ "HOME.SAVEANDCLOSE" | translate }}
                </button>
                <!-- <button type="button" class="btn-close" aria-label="Close"
                  (click)="modal.dismiss('Cross click')"></button> -->
              </div>
            </div>
          </div>
          <ng-container 
            [ngTemplateOutlet]="checklistInputForm" 
            [ngTemplateOutletContext]="{ $implicit: checklistItemss, condition: true }" >
          </ng-container>

          <ng-container *ngTemplateOutlet="attachmentdiv"></ng-container>
          
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #instructionanddocuments let-modal>
  <div class="instructions-popup">
    <div class="modal-header">
      <div
        class="d-flex align-items-center justify-content-between"
        style="width: 100%"
      >
        <h2 class="modal-title" style="color: #24597a">
          {{ "HOME.INSTRUCTDOCUMENT" | translate }}
        </h2>
        <div
          class="form-group"
          *ngIf="showInput"
          style="width: 42%"
          (keydown)="handleKeyDown($event)"
        >
          <input
            type="text"
            [(ngModel)]="inputText"
            id="inputvalue"
            (click)="diactivatedFlag = false"
            class="form-control"
            autofocus
          />
        </div>
        <div class="header-save-buttons">
        <div class="header-actions">
          <ng-container>
            <button
              type="button"
              *ngIf="customizing?.triggerPrint != null"
              class="btn prints-btn"
              (click)="
                postPrintDetails('0', false);
                diactivatedFlag = true;
                hideForUrl()
              "
            >
              {{ "HOME.PRINTBUTTON" | translate }}
            </button>
            <ng-container *ngIf="approverInfo">
              <ng-container [ngTemplateOutlet]="userDropdown" [ngTemplateOutletContext]="{ showNfc: selectedOption == 'checklist' }"></ng-container>
           </ng-container>
            <!-- [disabled]="+customizing?.allow_cancelChecklist === 0" -->
            <!-- <button
              type="button"
              class="btn blue-btn"
              (click)="addChecklist('',submitButton, false)"
            >
              {{ "HOME.SAVE" | translate }}
            </button> -->
            <button
            *ngIf="!isShoww && isD"
              type="button"
              class="btn print-btn"
              #submitButton
              [disabled]="autosave === 1 && isSaveButtonDisabled"
              (click)="addChecklist('',submitButton, true);"
              >
                {{ "HOME.SAVEANDCLOSE" | translate }}
              </button>
              <button
                type="button"
                class="btn print-btn"
                (click)="modal.dismiss('Cross clicked')"
                *ngIf="isShoww || !isD"
              >
              {{ "HOME.CLOSEBUTTON" | translate }}
              </button>
              <ng-container
              [ngTemplateOutlet]="closeiconbutton" 
              [ngTemplateOutletContext]="{ modal: modal }" 
              ></ng-container>
            </ng-container>
            </div>
            <ng-container *ngIf="saveMessage !== null">
          <div class="autosave-text" *ngIf="saveMessage">
            {{"HOME.AUTOSAVESUCCESS" | translate}}
          </div>
          <div class="autosave-text" *ngIf="!saveMessage">
            {{"HOME.AUTOSAVEFAIL" | translate}}
          </div>
        </ng-container>
        </div>
        <ng-container *ngIf="displayConcurrencyMessage && conurrentUsers && conurrentUsers.length > 0">
          <div class="concurrent-user-text" >
            {{"HOME.CONCURRENTUSERTEXT" | translate}} {{conurrentUsers.join(', ')}}.
          </div>
        </ng-container>
      </div>
    </div>

    <div class="modal-body" (click)="this.diactivatedFlag = false">
      <div class="instructions-content">
        <div class="instructions-content-left">
          <ul>
            <li
              *ngIf="
                customizing?.showInstructions != null ||
                customizing?.showInstructions == goodsRecipt ||
                goodsRecipt == '' ||
                true
              "
            >
              <a
                [ngClass]="isShoww ? 'chacive bold' : ''"
                class="checklisinstruction"
                (click)="
                  setOption('instructions', '');
                  isShoww = true;
                  isD = true;
                  diactivatedFlag = false;
                  inputText = ''
                "
                >{{ "HOME.INSTRUCTIONS_LABEL" | translate }}</a
              >
            </li>
            <li *ngIf="showChecklistOption">
              <a
                class="checklisinstruction"
                [ngClass]="(!isShoww && isD)? 'chacive bold' : ''"
                (click)="
                  setOption('checklist', '');
                  isShoww = false;
                  isD = true;
                  this.secondOrderId = ''
                "
                >{{ "HOME.CHECKLIST_LABEL" | translate }}</a
              >
            </li>
            
            <ng-container *ngIf="!this.pdfFlag">
              <li *ngFor="let items of attachments">
                <a
                  class="checklisinstruction"
                  [ngClass]="{
                    'chacive bold': selectedOption == items?.document_type 
                  }"
                  (click)="
                    setOption(items?.document_type, items);
                    isD = false;
                    isShoww = false
                  "
                  >{{ items?.document_type }}</a
                >
              </li>
            </ng-container>
          </ul>
        </div>

        <div class="projectbody instructions-content-right-desktop">
          
          <ng-container 
            [ngTemplateOutlet]="checklistInputForm" 
            [ngTemplateOutletContext]="{ $implicit: checklistItemss, condition: (!isShoww && isD), clickEvents: true }" >
          </ng-container> 

          <ng-container *ngIf="!isD">
            <ng-container *ngTemplateOutlet="attachmentdiv"></ng-container>
          </ng-container>

          <ng-container *ngIf="isShoww">
            <div class="row mt-3" *ngFor="let item of instructionsItems">
              <label [ngClass]="getClass(layoutValues[0])" class="instLabel">{{
                item?.fieldDescription
              }}</label>
              <label
                [ngClass]="getClass(layoutValues[1])"
                class="instLabel"
                *ngIf="item.fieldType == 'checkbox' && item?.value == null"
                ><input class="form-check-input" type="checkbox" disabled
              /></label>
              <label
                [ngClass]="getClass(layoutValues[0])"
                  class="instLabel"
                  *ngIf="item.fieldType == 'text' && item?.value == null"
                ></label>
                <label
                  class="col-sm-4 instLabel"
                  *ngIf="item.fieldType == 'checkbox' && item?.value != null"
                  ><input
                    class="form-check-input"
                    type="checkbox"
                    checked
                    disabled
                /></label>
                <label
                [ngClass]="[getClass(layoutValues[1]), item.highlight ? 'highlighted' : '']"
                  class="instLabel value-container"
                  *ngIf="item.fieldType == 'text' && item?.value != null"
                  >{{ item?.value }}</label
                >
              </div>
              
            
            <ng-container *ngTemplateOutlet="attachmentdiv"></ng-container>
            
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!--Modal-->
<ng-template #content let-modal>
  <div class="modal-body Order-line-popup">
    <form [formGroup]="productForm" novalidate>
      <div
        class="Order-line-block d-flex justify-content-between align-items-center"
      >
        <label>{{ "HOME.KIND_LABEL" | translate }}</label>
        <div class="input-group">
          <select
            class="form-control"
            [(ngModel)]="defaultValue"
            formControlName="types"
            (change)="onChangeLabel(defaultValue)"
            name=""
            id=""
          >
            <option
              value="{{ list?.processStep }}"
              *ngFor="let list of getPostValues?.types"
            >
              {{ list?.description }}
            </option>
          </select>
        </div>
      </div>
      <div
        *ngIf="this.getPostValues?.quantity"
        class="Order-line-block d-flex justify-content-between align-items-center"
      >
        <label>{{ "HOME.QUANTITY_LABEL" | translate }}</label>
        <div class="input-group">
          <input
            type="number"
            (select)="toSelectUrl($event)"
            (click)="diactivatedFlag = true; hideForUrl()"
            class="form-control order-input"
            min="1"
            formControlName="quantity"
          />
        </div>
      </div>
      <ng-container>
        <div
          class="Order-line-block d-flex justify-content-between align-items-center"
          *ngFor="let datas of parentResult"
        >
          <ng-container [ngSwitch]="datas.type">
            <label>{{ datas.description}} </label>
            <div class="input-group">
              <input
                type="number"
                inputmode="decimal"
                *ngSwitchCase="'int'"
                (select)="toSelectUrl($event)"
                (click)="diactivatedFlag = true; hideForUrl()"
                class="form-control order-input"
                min="1"
                [formControlName]="datas.id"
              />
            </div>
          </ng-container>
        </div>
      </ng-container>
      <!-- <div class="Order-line-block d-flex justify-content-between align-items-center">
        <label>{{ "HOME.DEFAULT_QUANTITY_LABEL" | translate }}</label>
        <div class="input-group">
          <input type="number" class="form-control order-input" min="1" formControlName="default_quantity" >
        </div>
      </div> -->

      <div
        class="d-flex justify-content-center align-items-center popup-actions"
      >
        <button class="btn next-button" (click)="postPrintDetails('1', true)">
          {{ "HOME.CONFIRMBUTTON" | translate }} 
        </button>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #extrainputmodal let-modal>
  <div class="modal-header">
    <ng-container
            [ngTemplateOutlet]="closeiconbutton" 
            [ngTemplateOutletContext]="{ modal: modal }" 
          ></ng-container>
  </div>
  <div class="modal-body Order-line-popup">
    <form
    (keydown.enter)="addChecklist('small',submitButton, true)"
      novalidate
      [formGroup]="checkListFormGroup"
      *ngIf="selectedOption == 'checklist'"
    >
      <ng-container 
        [ngTemplateOutlet]="simpleformfields" 
        [ngTemplateOutletContext]="{ $implicit: checkListItems }">
      </ng-container>
      <br />
    </form> 
  </div>
  <div class="modal-footer">
    <button
    [disabled]="+customizing?.allow_cancelChecklist === 0"
      type="button"
      class="btn btn-outline-dark cancelbtn"
      (click)="modal.close('Save click')"
    >
      {{ "HOME.CANCELBUTTON" | translate }}
    </button>
    <button
      type="button"
      class="btn btn-primary"
      #submitButton
      (click)="addChecklist('small',submitButton, true)"
    >
      {{ "HOME.CONFIRMBUTTON" | translate }}
    </button>
  </div>
</ng-template>


<ng-template #spoed let-modal>
  <form class="mb-0" [formGroup]="locatieForm" >
    <div class="row">
      <div class="col-md-12" *ngFor="let list of this.instructionsItems.canModify">
        <div class="formgroup">
          <ng-container [ngSwitch]="list?.type">
          <label class="mb-1" for="">{{list?.name}}</label>
          <input type="text" *ngSwitchCase="'text'" class="form-control mb-3"  [formControlName]="list?.name" name="" id="">
          </ng-container>
        </div>

       
      </div>
    
    </div>
<div class="d-flex justify-content-end" >    <button type="submit" (click)="locatieSubmit()" class="btn prints-btn py-2 px-3 h-auto">Submit</button>
</div>
  </form>

</ng-template>

<ng-template #confirmation  >

    <div class="modal-content">

      <div class="modal-body" [innerHTML]="formattedConfirmationMessage"></div>
 
       <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="close()">{{ "HOME.CANCELBUTTON" | translate }}</button>
        <button type="button" class="btn btn-primary" [disabled]="speedSaveDisabled" (click)="proceed()">{{ "HOME.CONTINUEBUTTON" | translate }} </button>
      </div>
    </div>

</ng-template>
 
<!-- Photo input field -->
<ng-template #photoInput let-prop>
  <div class="photo-grid" [ngClass]="{'error-border photo': hasAnyError(prop)}" >
    <div class="photo-item" *ngFor="let photo of getListField(prop)?.value; let i = index">
      <img [src]="photo" [alt]="i" class="img-item" />
      <button
        type="button"
        class="btn btn-danger remove-btn"
        aria-label="Remove Photo"
        (click)="removePhoto(i, prop)"
      >
        x
      </button>
    </div>

    <div class="photo-item input-item">
      <button
      type="button"
      class="btn btn-capture btn-item"
      (click)="openCamera(prop)"
      >
      <img src="../../assets/photo-camera.svg" alt="" class="btn-icon">
      {{ "HOME.TAKE_PHOTO" | translate }}
    </button>
    {{"HOME.OR" | translate}}
    <input
      type="file"
      accept="image/*"
      [id]="prop.fieldID ?? prop.fieldName"
      class="form-control"
      hidden
      (change)="onFileSelected($event, prop)" 
      (blur)="validateInput(prop)"
      />
      <button
      type="button"
      class="btn btn-grey btn-item"
      (click)="openFilePicker(prop)"
      >
      <img src="../../assets/gallery.svg" alt="" class="btn-icon">
      {{ "HOME.CHOOSE_PHOTO" | translate }}
    </button>
  </div>
  </div>
</ng-template>

<!-- Current user selection header dropdown -->
<ng-template #userDropdown let-modal let-showNfc="showNfc">
  <div class="approver-box">
  <div class="dropdown-title" *ngIf="!approverInfo.nfc_enabled || showNfc" >{{approverInfo.title}}</div>
  <ng-container *ngIf="approverInfo.options && approverInfo.options.length > 0 && !approverInfo.nfc_enabled">
      <div class="dropdown-container">
      <mat-select placeholder="Select value" [value]="selectedUserControl.value"
                  (selectionChange)="selectedUserControl.setValue($event.value)">
        <mat-option [value]="null" disabled>Select value</mat-option>
        <mat-option
        *ngFor="let user of approverInfo.options"
        [value]="user"
        >
          {{ user }}
        </mat-option>
      </mat-select>
    </div>
    </ng-container>
    <ng-container *ngIf="approverInfo.nfc_enabled && showNfc">
      <div class="nfc-wrapper" >
        <button type="button" class="nfc-button" aria-label="NFC action" (click)="onNfcButtonClick()" [ngClass]="nfcStatus">
          <svg id="svg" viewBox="115 0 550 650" preserveAspectRatio="xMidYMid meet" role="img" width="50" height="40" style="display:block;max-width:100%;height:auto;" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g fill="currentColor">
            <path d="m479.20948,54.19202c-9.53916,4.17497 -13.18096,15.2444 -8.88769,27.01584c1.92663,5.28459 2.11673,5.56457 14.95807,21.89594c82.75316,105.24298 81.21314,252.23564 -3.7251,355.31702c-8.14225,9.87952 -9.84674,12.56402 -11.57258,18.22946c-6.21562,20.39929 9.83178,33.4821 29.57865,24.11312c6.73252,-3.19505 12.19842,-8.61756 23.43566,-23.25672c83.61182,-108.90534 91.08764,-254.65457 19.02278,-370.94845c-27.34445,-44.1295 -46.03189,-59.70947 -62.80979,-52.36621m-93.89215,38.22732c-13.93281,6.16364 -14.21476,23.55728 -0.66428,41.08268c68.17743,88.18695 68.62598,201.8478 1.13419,288.02962c-13.74485,17.55216 -14.99224,33.5068 -3.20606,41.02298c12.10657,7.72205 27.9532,0.3438 43.07359,-20.05344c74.37383,-100.33306 73.5878,-232.93567 -1.9608,-330.88687c-13.31338,-17.25983 -27.12658,-24.17076 -38.37664,-19.19498m-94.96653,39.24841c-13.7064,6.74212 -12.87979,22.50942 2.32392,44.26743c45.39751,64.97964 43.73788,146.2289 -4.31462,211.01297c-13.81747,18.6309 -8.25118,39.15166 10.605,39.09401c12.66192,-0.03911 20.11212,-5.38135 32.46005,-23.27525c51.96342,-75.31001 51.99974,-173.78822 0.09185,-248.85943c-14.21689,-20.56193 -28.68583,-28.37867 -41.16619,-22.23974m-94.27876,38.91491c-11.36967,5.85484 -11.96987,23.17643 -1.37342,39.6725c27.1159,42.21083 27.09454,93.79887 -0.05553,136.3432c-23.79236,37.28239 13.43513,58.93953 38.35741,22.31385c35.64262,-52.38268 35.65757,-129.15435 0.03204,-181.24264c-10.58577,-15.47909 -26.13123,-22.66588 -36.9605,-17.0869m280.56789,377.76468c-50.8271,7.17856 -53.33257,90.64294 -2.99033,99.6393c19.13385,3.4215 36.6038,-2.66185 45.42528,-15.81671c3.29577,-4.91403 7.13621,-14.35506 6.08746,-14.96442c-1.03807,-0.60319 -17.57247,-5.45134 -18.59132,-5.45134c-0.54467,0 -1.48021,1.68399 -2.07828,3.74059c-4.77812,16.44872 -24.80267,21.75801 -37.21682,9.86717c-10.92326,-10.46213 -11.88443,-39.85778 -1.72371,-52.69766c9.64596,-12.18934 34.28843,-8.79049 38.63295,5.32782c0.487,1.58517 1.23885,2.84507 1.67031,2.79978c0.43146,-0.04323 4.91696,-0.96963 9.96848,-2.05866c10.65413,-2.29335 10.59005,-2.19453 6.57446,-10.30361c-7.45233,-15.05089 -25.45413,-22.95204 -45.75849,-20.08226m-224.17877,49.79289l0,49.02295l9.8446,0l9.84674,0l-0.23495,-31.29168c-0.12816,-17.21042 -0.04058,-31.27315 0.19437,-31.24845c0.23495,0.0247 5.39328,7.89909 11.46365,17.49864c6.06824,9.6016 15.02855,23.66227 19.91134,31.24845l8.87488,13.79304l10.20558,0l10.20558,0l0,-48.99618l0,-48.99618l-9.38751,0l-9.38964,0l-0.22214,32.32101l-0.22427,32.32101l-13.61455,-21.4101c-7.48865,-11.77555 -16.72023,-26.22737 -20.51154,-32.11514l-6.89485,-10.70505l-10.03256,-0.23263l-10.0347,-0.23057l0,49.02089m102.52566,0.02676l0,48.99618l10.25257,0l10.25257,0l0,-20.58663l0,-20.58663l20.93232,0l20.93232,0l0,-8.47346l0,-8.47346l-20.93232,0.12352l-20.93232,0.12146l0,-11.41117l0,-11.41323l24.34985,0l24.34985,0l0,-8.64639l0,-8.64639l-34.60241,0l-34.60241,0l0,48.99618m-379.14845,-18.99734c-0.12816,2.9583 0.15592,5.52133 0.64079,5.81161c0.51904,0.3088 0.87147,-0.4982 0.87147,-1.99896c0,-2.98712 -0.28835,-2.93359 4.69909,-0.87287c4.5453,1.8775 4.69909,1.90838 4.69909,0.92434c0,-0.39526 -2.05479,-1.59546 -4.56666,-2.66391c-6.05969,-2.57745 -5.876,-4.84815 0.39515,-4.84815c2.29401,0 4.17151,-0.37056 4.17151,-0.82347c0,-0.46114 -2.34955,-0.82347 -5.33988,-0.82347l-5.33988,0l-0.23068,5.29488m2.15304,7.6747c-1.60196,0.34997 -2.87285,3.66648 -1.95226,5.09931c0.94409,1.474 1.8775,0.96551 1.80701,-0.98198c-0.09825,-2.68656 2.93693,-2.82037 5.45095,-0.24086c2.79596,2.86772 3.4517,2.63921 3.4517,-1.2002c0,-3.65619 -1.66818,-4.62376 -1.77711,-1.02933c-0.03631,1.24549 -0.26272,1.7931 -0.50408,1.21873c-0.60875,-1.45959 -4.6756,-3.25886 -6.4762,-2.86566m-1.00603,8.91195c-1.68099,1.61811 -1.72585,3.96087 -0.10253,5.25988c1.77498,1.42048 4.1053,0.74729 5.28007,-1.52547l1.01244,-1.95367l1.13846,1.75604c1.21963,1.88162 2.43498,2.316 2.43498,0.86876c0,-3.5409 -7.26223,-6.81829 -9.76343,-4.40554m3.49655,3.17858c-0.28408,0.71024 -0.92273,1.29078 -1.42254,1.29078c-1.46953,0 -2.06333,-2.57333 -0.77321,-3.34327c1.51653,-0.90169 2.86858,0.36232 2.19576,2.05249m-4.84007,6.07511c0,1.56047 2.50761,3.95469 2.53537,2.42099c0.0235,-1.17756 0.81166,-1.44106 4.29967,-1.44106c2.34955,0 4.2719,-0.37056 4.2719,-0.82347c0,-0.46526 -2.42003,-0.82347 -5.55347,-0.82347c-3.05441,0 -5.55347,0.30056 -5.55347,0.66701m6.42494,5.07049c-0.27981,0.4385 -1.62973,0.58054 -2.99888,0.31703c-2.76819,-0.53319 -4.68201,2.94595 -2.68062,4.87491c2.62936,2.53421 10.3615,1.1055 10.3615,-1.9125c0,-2.64332 -3.5115,-5.10343 -4.68201,-3.27945m-2.31537,3.11476c-0.34816,1.73545 -1.86255,1.62634 -2.24916,-0.16263c-0.16233,-0.74524 0.30971,-1.27843 1.12992,-1.27843c0.88001,0 1.29866,0.53937 1.11924,1.44106m5.12628,0c-0.15806,0.79259 -0.85438,1.44106 -1.54643,1.44106c-0.69205,0 -1.38837,-0.64848 -1.54643,-1.44106c-0.20078,-1.0108 0.26059,-1.44106 1.54643,-1.44106c1.28584,0 1.74721,0.43026 1.54643,1.44106m-6.88631,5.76426c-1.60196,0.34997 -2.87285,3.66648 -1.95226,5.09931c0.94409,1.474 1.8775,0.96551 1.80701,-0.98198c-0.09825,-2.68656 2.93693,-2.82037 5.45095,-0.24086c2.79596,2.86772 3.4517,2.63921 3.4517,-1.2002c0,-3.65619 -1.66818,-4.62376 -1.77711,-1.02933c-0.03631,1.24549 -0.26272,1.7931 -0.50408,1.21873c-0.60875,-1.45959 -4.6756,-3.25886 -6.4762,-2.86566m0,8.23465c-1.60196,0.34997 -2.87285,3.66648 -1.95226,5.09931c0.94409,1.474 1.8775,0.96551 1.80701,-0.98198c-0.09825,-2.68656 2.93693,-2.82037 5.45095,-0.24086c2.79596,2.86772 3.4517,2.63921 3.4517,-1.2002c0,-3.65619 -1.66818,-4.62376 -1.77711,-1.02933c-0.03631,1.24549 -0.26272,1.7931 -0.50408,1.21873c-0.60875,-1.45959 -4.6756,-3.25886 -6.4762,-2.86566m3.315,8.1976c-0.33107,0.31909 -1.64468,0.59701 -2.91985,0.6176c-2.43071,0.03911 -3.59267,4.43024 -1.3606,5.14872c0.60234,0.19351 0.80312,-0.4632 0.5404,-1.78486c-0.30544,-1.54194 -0.05126,-2.0916 0.96545,-2.0916c0.7604,0 1.38196,0.55584 1.38196,1.2352c0,1.85074 1.44177,1.48841 1.98003,-0.4982c0.65147,-2.40452 2.72761,-1.48018 2.68489,1.19608c-0.03631,2.39834 1.07225,2.92742 1.88177,0.89552c1.20895,-3.03447 -2.94975,-6.843 -5.15405,-4.71846m-3.1014,7.70352c0,0.47967 -0.38447,0.6423 -0.85438,0.36232c-0.46991,-0.27998 -0.85438,-0.14822 -0.85438,0.29439c0,0.44261 0.48059,1.01904 1.06798,1.28461c0.84797,0.38085 0.85011,0.57848 0.00854,0.95728c-0.81166,0.36644 -0.76253,0.76582 0.20719,1.70046c0.69632,0.67112 1.69595,0.96345 2.22353,0.65054c0.52544,-0.31292 1.23031,-0.13999 1.56779,0.38497c0.40583,0.63201 1.28584,0.71436 2.60586,0.24498c1.66818,-0.59495 1.76002,-0.7967 0.57243,-1.2352c-1.901,-0.70406 -1.82837,-2.30982 0.07689,-1.6634c1.10429,0.37262 0.96759,0.01441 -0.5169,-1.37519c-1.6041,-1.50077 -2.15945,-1.65517 -2.73188,-0.76171c-0.57671,0.89964 -0.82875,0.83993 -1.28157,-0.29851c-0.61943,-1.55429 -2.0911,-1.93926 -2.0911,-0.54555m-4.2719,13.9495c0,0.49202 3.27441,0.82347 8.11662,0.82347c4.8422,0 8.11662,-0.33144 8.11662,-0.82347c0,-0.49202 -3.27441,-0.82347 -8.11662,-0.82347c-4.8422,0 -8.11662,0.33144 -8.11662,0.82347m10.34441,7.49559c-1.92236,1.509 -2.14022,1.52135 -3.63753,0.21616c-0.8736,-0.76376 -1.8775,-1.11168 -2.22566,-0.77406c-0.3503,0.33762 0.27127,1.32372 1.37982,2.19042l2.01847,1.57694l-3.94083,0c-2.93053,0 -3.93869,0.31498 -3.93869,1.2352c0,0.98816 1.28157,1.2352 6.40785,1.2352c5.12628,0 6.40785,-0.24704 6.40785,-1.2352c0,-0.72671 -0.79244,-1.24343 -1.92236,-1.25373l-1.92236,-0.01853l2.03556,-1.50694c1.11924,-0.82964 1.88818,-1.90632 1.70876,-2.39011c-0.19437,-0.52702 -1.15128,-0.23469 -2.37091,0.72465m-6.07251,8.91401c0,2.17807 2.26411,4.17703 4.729,4.17703c2.06119,0 3.81481,-2.05866 3.81481,-4.47553c0,-1.99279 -1.55497,-1.52135 -1.86255,0.56407c-0.20078,1.35666 -0.84584,1.8528 -2.40935,1.8528c-1.56352,0 -2.20857,-0.49614 -2.40935,-1.8528c-0.33321,-2.26041 -1.86255,-2.47863 -1.86255,-0.26557m1.34351,7.11886c-1.57633,1.51723 -1.65963,2.35923 -0.45923,4.52288c1.00176,1.80545 5.00881,2.17189 6.63426,0.60525c2.26197,-2.18012 0.11748,-6.42303 -3.24665,-6.42303c-0.8736,0 -2.19149,0.5826 -2.92839,1.2949m5.06434,2.4004c0,1.81574 -2.65712,2.71949 -4.04976,1.37725c-1.43536,-1.38342 -0.01922,-3.56972 2.12314,-3.27739c1.26021,0.17293 1.92663,0.82964 1.92663,1.90015m-6.40785,5.36282c0,0.45291 -0.57671,0.82347 -1.28157,0.82347c-0.70486,0 -1.28157,0.37056 -1.28157,0.82347c0,0.45291 0.54467,0.82347 1.21108,0.82347c0.66428,0 1.38623,0.4632 1.60196,1.02933c0.31185,0.82347 0.61729,0.82347 1.52293,0c0.6237,-0.56613 2.40081,-1.02933 3.95151,-1.02933c2.24916,0 2.81946,-0.3335 2.81946,-1.64693c0,-0.90581 -0.38447,-1.64693 -0.85438,-1.64693c-0.46991,0 -0.85438,0.37056 -0.85438,0.82347c0,0.45291 -1.15341,0.82347 -2.56314,0.82347c-1.40973,0 -2.56314,-0.37056 -2.56314,-0.82347c0,-0.45291 -0.38447,-0.82347 -0.85438,-0.82347c-0.46991,0 -0.85438,0.37056 -0.85438,0.82347m1.88177,7.40501c-1.63187,2.76684 -3.02664,2.82654 -3.43675,0.14822c-0.36311,-2.38393 -1.86255,-2.29747 -1.86255,0.10499c0,4.2882 4.41074,5.21871 6.66203,1.40607c1.72158,-2.91713 3.17616,-2.78331 3.12917,0.29027c-0.04058,2.60627 1.61905,2.44157 2.02275,-0.19969c0.66642,-4.38495 -4.1886,-5.68809 -6.51465,-1.74986m-1.04875,11.14766c-1.82197,2.11631 0.24991,5.32782 3.43888,5.32782c2.96897,0 4.99599,-2.93154 3.80627,-5.50487c-0.60234,-1.30519 -0.73263,-1.2352 -1.03807,0.56407c-0.55535,3.27533 -1.91381,3.97528 -1.91381,0.98816c0,-2.94389 -2.30683,-3.68295 -4.29326,-1.37519m2.5845,2.08337c0,0.93257 -0.38447,1.46577 -0.85438,1.18579c-0.46991,-0.27998 -0.85438,-1.04374 -0.85438,-1.69634c0,-0.6526 0.38447,-1.18579 0.85438,-1.18579c0.46991,0 0.85438,0.76376 0.85438,1.69634m-2.82373,7.36178c-0.68564,1.74986 -1.53575,2.4704 -2.91771,2.4704c-1.18545,0 -1.94799,0.49614 -1.94799,1.27225c0,2.40864 12.31162,1.30725 12.67046,-1.13432c0.70059,-4.75963 -6.07678,-7.0221 -7.80477,-2.60833m5.21599,0.16469c1.66177,1.60164 1.19186,2.3057 -1.53788,2.3057c-1.56565,0 -2.56314,-0.42614 -2.56314,-1.09727c0,-2.25629 2.30896,-2.93565 4.10103,-1.20844m-5.01308,8.17495c-1.49089,2.6845 0.23709,5.65926 3.28509,5.65926c2.74043,0 4.462,-1.31137 4.462,-3.39885c0,-3.72206 -5.96785,-5.46369 -7.7471,-2.26041m5.61114,1.94338c0,1.81574 -2.65712,2.71949 -4.04976,1.37725c-1.43536,-1.38342 -0.01922,-3.56972 2.12314,-3.27739c1.26021,0.17293 1.92663,0.82964 1.92663,1.90015m-10.67976,6.57537c0,0.77817 0.77962,1.25784 2.04411,1.25784c1.46313,0 2.19362,0.58054 2.57596,2.04631c1.00176,3.84558 6.85,3.83529 7.85176,-0.01235c0.7604,-2.9233 -0.01495,-3.38856 -6.70475,-4.01233c-4.84647,-0.45291 -5.76707,-0.33762 -5.76707,0.72053m10.94461,2.69891c-0.18156,0.90993 -1.06798,1.44106 -2.40081,1.44106c-1.33283,0 -2.21925,-0.53114 -2.40081,-1.44106c-0.22427,-1.12609 0.30117,-1.44106 2.40081,-1.44106c2.09964,0 2.62508,0.31498 2.40081,1.44106m-4.10957,6.3098c-7.46729,2.49922 -7.46942,3.76118 -0.01068,5.93924c3.29577,0.96345 5.99134,1.39166 5.99134,0.95316c0,-0.4385 -0.76894,-0.99228 -1.70876,-1.22902c-1.21108,-0.30468 -1.70876,-1.12403 -1.70876,-2.80596c0,-1.82398 0.39515,-2.37364 1.70876,-2.37364c0.94836,0 1.70876,-0.54966 1.70876,-1.2352c0,-0.67936 -0.09612,-1.20638 -0.2136,-1.17138c-0.11748,0.035 -2.71266,0.90169 -5.76707,1.92279m0.71127,3.62531c-0.15592,0.3685 -1.24526,0.41791 -2.42003,0.11117l-2.13595,-0.55996l2.13595,-0.83376c2.01207,-0.78641 3.06295,-0.23057 2.42003,1.28255" id="path0"/>
          </g>
          </svg>
        </button>
      </div>
    </ng-container>
  </div>
</ng-template>

<!-- Advanced checklist form (with pagination, conditional parsing, etc.) -->
<ng-template #checklistInputForm let-checklistItemss let-condition="condition" let-clickEvents="clickEvents">
    <ng-container *ngIf="condition">
            <form
              novalidate
              [formGroup]="checkListFormGroup"
            >
              <div *ngFor="let prop of checklistItemss">
                <div class="row mt-3 field" *ngIf="fieldVisibility(prop)">
                  <ng-container *ngIf="prop.fieldType === 'section_header'">
                    <h5 class="section-header">{{ prop.fieldName }}</h5>
                  </ng-container>
                  <ng-container *ngIf="prop.fieldType !== 'section_header'">
                  <label 
                    [attr.for]="prop.fieldID ?? prop.fieldName"
                    class="col-sm-{{layout ? layout[0] : 4}} d-flex p-2 form-label"
                    style="color: #24597a;  white-space: pre-line;"
                    >
                      <div class="dynamic-content" [innerHTML]="prop.safeFieldLabel"></div>
                    </label>
                    <!-- [ngClass]="{'hide':(prop.showDependingOn) && !isshowDependingOn}" -->
                  <ng-container [ngSwitch]="prop.fieldType">
                    <div class="col-sm-{{layout ? layout[1] : 8}}" >
                      <input
                        type="text"
                        hidden="true"
                        formControlName="details"
                      />

                      <textarea
                        *ngSwitchCase="'textarea'"
                        class="form-control"
                        [ngClass]="{'error-border': hasAnyError(prop)}"
                        [formControlName]="prop.fieldID ?? prop.fieldName"
                        [id]="prop.fieldID ?? prop.fieldName"
                        [ngClass]="{'hide':(prop.showDependingOn) && !isshowDependingOn, 'textarea': clickEvents && prop.textarea}"
                        [value]="prop?.value"
                        [placeholder]="prop?.placeholder ? prop?.placeholder : ''"
                        name=""
                        id=""
                        cols="1"
                        [rows]="prop.addrows"
                        (click)="onInputClick(clickEvents, $event)"
                        (blur)="validateInput(prop)"
                        (select)="clickEvents ? (toSelectUrl($event)) : null"
                      ></textarea>

                      <input
                      *ngSwitchCase="'text'"
                      class="form-control"
                        [ngClass]="{'error-border': hasAnyError(prop)}"
                        [name]="prop.fieldID ?? prop.fieldName"
                        [formControlName]="prop.fieldID ?? prop.fieldName"
                        [id]="prop.fieldID ?? prop.fieldName"
                        [type]="prop.fieldType"
                        [value]="prop?.value"
                        [placeholder]="prop?.placeholder ? prop?.placeholder : ''"
                        (click)="onInputClick(clickEvents, $event)"
                        (blur)="validateInput(prop)"
                        (select)="clickEvents ? (toSelectUrl($event)) : null"
                        />
                      <div  *ngSwitchCase="'boolean'" [ngClass]="{'error-border boolean': hasAnyError(prop)}" >
                        <label *ngFor="let option of prop.options" >
                            <input
                              type="radio"
                              style="transform: scale(1.5); margin-right: 8px;"
                              [formControlName]="prop.fieldID ?? prop.fieldName"
                              [value]="option.id"
                              [name]="prop.fieldID ?? prop.fieldName"
                              (change)="onChangeRadio($event,option.id,prop);"
                              (click)="onInputClick(clickEvents, $event)"
                              (blur)="validateInput(prop);"
                              (select)="clickEvents ? toSelectUrl($event) : ''"
                            />
                            {{ option.description }}  &nbsp;&nbsp;&nbsp;
                        </label>
                      </div>
                      <div *ngSwitchCase="'int'" class="number-input-wrapper">
                        <input class="form-control"
                              pattern="-?[0-9]*\.?[0-9]*"
                              [name]="prop.fieldID ?? prop.fieldName"
                              inputmode="decimal"
                              [formControlName]="prop.fieldID ?? prop.fieldName"
                              appMinmax
                              [min]="prop.min !== undefined ? prop.min : 0"
                              [max]="prop.max !== undefined ? prop.max : ''"
                              [id]="prop.fieldID ?? prop.fieldName"
                              type="number"
                              [value]="prop?.value"
                              [placeholder]="prop?.placeholder ? prop?.placeholder : ''" />
                        <div class="spinner-buttons">
                          <button type="button" class="spin-btn spin-up"
                                  (click)="stepValue(prop, 1, true)"
                                  [ngStyle]="{display: isFormDisabled(prop.fieldID ?? prop.fieldName) ? 'none' : undefined}"
                                  (pointerdown)="startSpin(prop, 1, true)"
                                  (pointerup)="stopSpin()"
                                  (pointerleave)="stopSpin()">▲</button>
                          <button type="button" class="spin-btn spin-down"
                                  (click)="stepValue(prop, -1, true)"
                                  [ngStyle]="{display: isFormDisabled(prop.fieldID ?? prop.fieldName) ? 'none' : undefined}"
                                  (pointerdown)="startSpin(prop, -1, true)"
                                  (pointerup)="stopSpin()"
                                  (pointerleave)="stopSpin()">▼</button>
                        </div>
                      </div>

                      <div *ngSwitchCase="'float'" class="number-input-wrapper">
                        <input class="form-control"
                              pattern="-?[0-9]*\.?[0-9]*"
                              inputmode="decimal"
                              [formControlName]="prop.fieldID ?? prop.fieldName"
                              [id]="prop.fieldID ?? prop.fieldName"
                              type="number"
                              step="any"
                              [value]="prop?.value"
                              [placeholder]="prop?.placeholder ? prop?.placeholder : ''"
                              [name]="prop.fieldID ?? prop.fieldName" />
                        <div class="spinner-buttons">
                          <button type="button" class="spin-btn spin-up"
                                  [ngStyle]="{display: isFormDisabled(prop.fieldID ?? prop.fieldName) ? 'none' : undefined}"
                                  (click)="stepValue(prop, 1, false)"
                                  (pointerdown)="startSpin(prop, 0.1, false)"
                                  (pointerup)="stopSpin()"
                                  (pointerleave)="stopSpin()">▲</button>
                          <button type="button" class="spin-btn spin-down"
                                  [ngStyle]="{display: isFormDisabled(prop.fieldID ?? prop.fieldName) ? 'none' : undefined}"
                                  (click)="stepValue(prop, -1, false)"
                                  (pointerdown)="startSpin(prop, -0.1, false)"
                                  (pointerup)="stopSpin()"
                                  (pointerleave)="stopSpin()">▼</button>
                        </div>
                      </div>

                      <input
                        *ngSwitchCase="'string'"
                        [ngClass]="{'hide':(prop.showDependingOn) && !isshowDependingOn}"
                        class="form-control"
                        [name]="prop.fieldID ?? prop.fieldName"
                        [formControlName]="prop.fieldID ?? prop.fieldName"
                        [id]="prop.fieldID ?? prop.fieldName"
                        type="varchar"
                        [value]="prop?.value"
                        [placeholder]="prop?.placeholder ? prop?.placeholder : ''"
                        (click)="onInputClick(clickEvents, $event)"
                        (select)="clickEvents ? (toSelectUrl($event)) : null"
                      />

                      <input
                        *ngSwitchCase="'file'"
                        type="file"
                        [id]="prop.fieldID ?? prop.fieldName"
                        [name]="prop.fieldID ?? prop.fieldName"
                        [formControlName]="prop.fieldID ?? prop.fieldName"
                        (click)="onInputClick(clickEvents, $event)"
                        (select)="clickEvents ? (toSelectUrl($event)) : null"
                      />
                      <input
                        *ngSwitchCase="'checkbox'"
                        [ngClass]="[
                          prop.protected === true ||
                          prop.protected == 'true' ||
                          +prop.protected === 1
                            ? 'active'
                            : 'in-active'
                        ]"
                        class="form-check-input"
                        [name]="prop.fieldID ?? prop.fieldName"
                        [checked]="prop.value"
                        [ngClass]="{'hide':(prop.showDependingOn) && !isshowDependingOn}"
                        type="checkbox"
                        [id]="prop.fieldID ?? prop.fieldName"
                        [formControlName]="prop.fieldID ?? prop.fieldName"
                        (click)="onInputClick(clickEvents, $event)"
                        (select)="clickEvents ? (toSelectUrl($event)) : null"
                      />

                      <input
                        *ngSwitchCase="'email'"
                        type="email"
                        [name]="prop.fieldID ?? prop.fieldName"
                        [id]="prop.fieldID ?? prop.fieldName"
                        [value]="prop?.value"
                        [formControlName]="prop.fieldID ?? prop.fieldName"
                        [placeholder]="prop?.placeholder ? prop?.placeholder : ''"
                        (click)="onInputClick(clickEvents, $event)"
                        (select)="clickEvents ? (toSelectUrl($event)) : null"
                      />

                      <div class="input-group" *ngSwitchCase="'date'">
                        <input
                          class="form-control dateicon"
                          [name]="prop.fieldID ?? prop.fieldName"
                          matInput
                          [matDatepicker]="dp"
                          (click)="dp.open()"
                          [id]="prop.key"
                          [formControlName]="prop.fieldID ?? prop.fieldName"
                          (click)="onInputClick(clickEvents, $event)"
                          (select)="clickEvents ? toSelectUrl($event) : ''"
                        />
                        <mat-datepicker-toggle
                          class="date"
                          matSuffix
                          [for]="dp"
                          id="datepicker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #dp></mat-datepicker>
                      </div>

                      <input
                        *ngSwitchCase="'datetime'"
                        type="datetime"
                        [id]="prop.fieldID ?? prop.fieldName"
                        [value]="prop?.value"
                        [formControlName]="prop.fieldID ?? prop.fieldName"
                        (click)="onInputClick(clickEvents, $event)"
                        (select)="clickEvents ? (toSelectUrl($event)) : null"
                      />

                      <input
                        *ngSwitchCase="'reset'"
                        type="reset"
                        [name]="prop.fieldID ?? prop.fieldName"
                        [id]="prop.fieldID ?? prop.fieldName"
                        [value]="prop?.value"
                        [formControlName]="prop.fieldID ?? prop.fieldName"
                        [placeholder]="prop?.placeholder ? prop?.placeholder : ''"
                        (click)="onInputClick(clickEvents, $event)"
                        (select)="clickEvents ? (toSelectUrl($event)) : null"
                      />

                      <input
                        *ngSwitchCase="'tel'"
                        type="tel"
                        [name]="prop.fieldID ?? prop.fieldName"
                        [id]="prop.fieldID ?? prop.fieldName"
                        [value]="prop?.value"
                        [formControlName]="prop.fieldID ?? prop.fieldName"
                        [placeholder]="prop?.placeholder ? prop?.placeholder : ''"
                        (click)="onInputClick(clickEvents, $event)"
                        (select)="clickEvents ? (toSelectUrl($event)) : null"
                      />

                      <input
                        *ngSwitchCase="'url'"
                        type="url"
                        [name]="prop.fieldID ?? prop.fieldName"
                        [id]="prop.fieldID ?? prop.fieldName"
                        [value]="prop?.value"
                        [formControlName]="prop.fieldID ?? prop.fieldName"
                        [placeholder]="prop?.placeholder ? prop?.placeholder : ''"
                        (click)="onInputClick(clickEvents, $event)"
                        (select)="clickEvents ? (toSelectUrl($event)) : null"
                      />

                      <mat-select
                        class="form-control"
                        placeholder="{{
                          prop['multi-select'] &&
                          prop.value[0] == '' &&
                          prop.options[0].id == ''
                            ? prop.options[0].description
                            : !prop['multi-select'] &&
                              prop.value == '' &&
                              prop.options[0].id == ''
                            ? prop.options[0].description
                            : ''
                        }}"
                        *ngSwitchCase="'select'"
                        [(value)]="prop.value"
                        multiple="{{ prop['multi-select'] }}"
                        [formControlName]="prop.fieldID ?? prop.fieldName"
                      >
                        <ng-container *ngFor="let list of prop.options">
                          <mat-option [value]="list.id" *ngIf="list.id != ''">
                            {{ list.description }}
                          </mat-option>
                        </ng-container>
                      </mat-select>


                      <!-- Photo -->
                        <ng-container *ngSwitchCase="'photo'" >
                          <ng-container *ngIf="fieldVisibility(prop)">
                            <ng-container *ngTemplateOutlet="photoInput; context: { $implicit: prop }"></ng-container>
                          </ng-container>
                        </ng-container>
                        <div class="error-message-box">
                        <div class="error-msg" *ngIf="prop?.errors?.minLength && prop.fieldType !== 'boolean'">
                           {{ "HOME.MINLENGTH" | translate }} {{prop.minLength}}
                        </div>
                        <div class="error-msg" *ngIf="prop?.errors?.maxLength">
                          {{ "HOME.MAXLENGTH" | translate }} {{prop.maxLength}}
                        </div>
                        <div class="error-msg" *ngIf="prop?.errors?.minLength && prop.fieldType == 'boolean'">
                          {{ "HOME.REQUIRED" | translate }}
                        </div>
                        <div class="error-msg" *ngIf="prop?.errors?.minValue">
                          {{ "HOME.MINVALUE" | translate }} {{prop.minValue}}
                        </div>
                        <div class="error-msg" *ngIf="prop?.errors?.maxValue">
                          {{ "HOME.MAXVALUE" | translate }} {{prop.maxValue}}
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  </ng-container>
                </div>
              </div>
              <br />
            </form>
            <div class="action-buttons">
              
              <ng-container *ngIf="maxIndex !== 0">
                <button class="btn prints-btn" (click)="prevData()" [disabled]="index === 1"> {{ "HOME.PREV" | translate }}</button>
                <button *ngIf="!(index === maxIndex)" class="btn prints-btn"  (click)="nextData()" > {{ "HOME.NEXT" | translate }}</button>
                <button #submitButton *ngIf="(index === maxIndex)" class="btn prints-btn btn-primary"  (click)="(addChecklist('',submitButton, true, false))" > {{ "HOME.SUBMIT" | translate }}</button>
              </ng-container>
            </div>
           
          </ng-container>
</ng-template>

<!-- Close icon -->
<ng-template #closeiconbutton let-modal="modal">
  <button
    [disabled]="+customizing?.allow_cancelChecklist === 0"
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="modal.dismiss('Cross click'); clearSubscriptions();"
  ></button>
</ng-template>

<!-- Simpler form field dynamic loop for checklist -->
<ng-template #simpleformfields let-list>
  <form [formGroup]="checkListFormGroup">
  <div *ngFor="let prop of list">
  <div class="row mt-3 field">
    <label [attr.for]="prop.fieldID ?? prop.fieldName" class="col-sm-4 d-flex p-2 form-label" style="color: #24597a">{{ prop.fieldID ?? prop.fieldName }}</label>

    <ng-container [ngSwitch]="prop.fieldType">
      <div class="col-sm-8 d-flex align-items-center" >
        <input type="text" hidden="true" formControlName="details" />

        <textarea *ngSwitchCase="'textarea'" [ngClass]="{ textarea: prop.textarea }" class="form-control"
          [name]="prop.fieldID ?? prop.fieldName" [formControlName]="prop.fieldID ?? prop.fieldName" [id]="prop.fieldID ?? prop.fieldName" [value]="prop?.value"
          [placeholder]="prop?.placeholder ? prop?.placeholder : ''" name="" id="" cols="1"
          [rows]="prop.addrows"></textarea>

        <input *ngSwitchCase="'text'" [ngClass]="errorMsg ? 'errormsg' : ''" class="form-control"
          [formControlName]="prop.fieldID ?? prop.fieldName" [id]="prop.fieldID ?? prop.fieldName" [type]="prop.fieldType" [value]="prop?.value"
          [name]="prop.fieldID ?? prop.fieldName" [placeholder]="prop?.placeholder ? prop?.placeholder : ''" />

        <div *ngSwitchCase="'int'" class="number-input-wrapper">
          <input
            class="form-control"
            pattern="-?[0-9]*\.?[0-9]*"
            [name]="prop.fieldID ?? prop.fieldName"
            inputmode="decimal"
            [formControlName]="prop.fieldID ?? prop.fieldName"
            appMinmax
            [min]="prop.min !== undefined ? prop.min : 0"
            [max]="prop.max !== undefined ? prop.max : ''"
            [id]="prop.fieldID ?? prop.fieldName"
            type="number"
            [value]="prop?.value"
            [placeholder]="prop?.placeholder ? prop?.placeholder : ''"
          />
          <div class="spinner-buttons">
            <button type="button" class="spin-btn spin-up"
                    (click)="stepValue(prop, 1, true)"
                    [ngStyle]="{display: isFormDisabled(prop.fieldID ?? prop.fieldName) ? 'none' : undefined}"
                    (pointerdown)="startSpin(prop, 1, true)"
                    (pointerup)="stopSpin()"
                    (pointerleave)="stopSpin()">▲</button>
            <button type="button" class="spin-btn spin-down"
                    (click)="stepValue(prop, -1, true)"
                    [ngStyle]="{display: isFormDisabled(prop.fieldID ?? prop.fieldName) ? 'none' : undefined}"
                    (pointerdown)="startSpin(prop, -1, true)"
                    (pointerup)="stopSpin()"
                    (pointerleave)="stopSpin()">▼</button>
          </div>
        </div>

        <div *ngSwitchCase="'float'" class="number-input-wrapper">
          <input
            class="form-control"
            pattern="-?[0-9]*\.?[0-9]*"
            inputmode="decimal"
            [formControlName]="prop.fieldID ?? prop.fieldName"
            [id]="prop.fieldID ?? prop.fieldName"
            type="number"
            step="any"
            [value]="prop?.value"
            [placeholder]="prop?.placeholder ? prop?.placeholder : ''"
            [name]="prop.fieldID ?? prop.fieldName"
          />
          <div class="spinner-buttons">
            <button type="button" class="spin-btn spin-up"
                    [ngStyle]="{display: isFormDisabled(prop.fieldID ?? prop.fieldName) ? 'none' : undefined}"
                    (click)="stepValue(prop, 1, false)"
                    (pointerdown)="startSpin(prop, 1, false)"
                    (pointerup)="stopSpin()"
                    (pointerleave)="stopSpin()">▲</button>
            <button type="button" class="spin-btn spin-down"
                    [ngStyle]="{display: isFormDisabled(prop.fieldID ?? prop.fieldName) ? 'none' : undefined}"
                    (click)="stepValue(prop, -1, false)"
                    (pointerdown)="startSpin(prop, -1, false)"
                    (pointerup)="stopSpin()"
                    (pointerleave)="stopSpin()">▼</button>
          </div>
        </div>

        <input *ngSwitchCase="'string'" class="form-control" [name]="prop.fieldID ?? prop.fieldName" [formControlName]="prop.fieldID ?? prop.fieldName"
          [id]="prop.fieldID ?? prop.fieldName" type="varchar" [value]="prop?.value"
          [placeholder]="prop?.placeholder ? prop?.placeholder : ''" />

        <input *ngSwitchCase="'file'" type="file" [id]="prop.fieldID ?? prop.fieldName" [name]="prop.fieldID ?? prop.fieldName"
          [formControlName]="prop.fieldID ?? prop.fieldName" />
        <input *ngSwitchCase="'checkbox'" [ngClass]="[
                        prop.protected === true ||
                        prop.protected == 'true' ||
                        +prop.protected === 1
                          ? 'active'
                          : 'in-active'
                        ]" class="form-check-input" [name]="prop.fieldID ?? prop.fieldName" [checked]="prop.value" type="checkbox"
          [id]="prop.fieldID ?? prop.fieldName" [formControlName]="prop.fieldID ?? prop.fieldName" />

        <input *ngSwitchCase="'email'" type="email" [id]="prop.fieldID ?? prop.fieldName" [name]="prop.fieldID ?? prop.fieldName" [value]="prop?.value"
          [formControlName]="prop.fieldID ?? prop.fieldName" [placeholder]="prop?.placeholder ? prop?.placeholder : ''" />

        <div class="input-group" *ngSwitchCase="'date'">
          <input class="form-control dateicon" matInput [matDatepicker]="dp" (click)="dp.open()" [id]="prop.key"
            [name]="prop.fieldID ?? prop.fieldName" [formControlName]="prop.fieldID ?? prop.fieldName" />
          <mat-datepicker-toggle class="date" matSuffix [for]="dp" id="datepicker"></mat-datepicker-toggle>
          <mat-datepicker #dp></mat-datepicker>
        </div>

        <input *ngSwitchCase="'datetime'" type="datetime" [id]="prop.fieldID ?? prop.fieldName" [name]="prop.fieldID ?? prop.fieldName"
          [value]="prop?.value" [formControlName]="prop.fieldID ?? prop.fieldName" />

        <input *ngSwitchCase="'reset'" type="reset" [id]="prop.fieldID ?? prop.fieldName" [name]="prop.fieldID ?? prop.fieldName" [value]="prop?.value"
          [formControlName]="prop.fieldID ?? prop.fieldName" [placeholder]="prop?.placeholder ? prop?.placeholder : ''" />

        <input *ngSwitchCase="'tel'" type="tel" [id]="prop.fieldID ?? prop.fieldName" [name]="prop.fieldID ?? prop.fieldName" [value]="prop?.value"
          [formControlName]="prop.fieldID ?? prop.fieldName" [placeholder]="prop?.placeholder ? prop?.placeholder : ''" />

        <input *ngSwitchCase="'url'" type="url" [id]="prop.fieldID ?? prop.fieldName" [name]="prop.fieldID ?? prop.fieldName" [value]="prop?.value"
          [formControlName]="prop.fieldID ?? prop.fieldName" [placeholder]="prop?.placeholder ? prop?.placeholder : ''" />

        <ng-container *ngSwitchCase="'photo'">
          <ng-container *ngIf="fieldVisibility(prop)">
            <ng-container *ngTemplateOutlet="photoInput; context: { $implicit: prop }"></ng-container>
          </ng-container>
        </ng-container>

        <mat-select class="form-control" placeholder="{{
                        prop['multi-select'] &&
                        prop.value[0] == '' &&
                        prop.options[0].id == ''
                          ? prop.options[0].description
                          : !prop['multi-select'] &&
                            prop.value == '' &&
                            prop.options[0].id == ''
                          ? prop.options[0].description
                          : ''
                      }}" *ngSwitchCase="'select'" [(value)]="prop.value" multiple="{{ prop['multi-select'] }}"
          [formControlName]="prop.fieldID ?? prop.fieldName">
          <ng-container *ngFor="let list of prop.options">
            <mat-option [value]="list.id" *ngIf="list.id != ''">
              {{ list.description }}
            </mat-option>
          </ng-container>
        </mat-select>
      </div>
    </ng-container>
  </div>
</div>
</form>
</ng-template>

<!-- attachments content -->
<ng-template #attachmentdiv let-data>
  <div
    class="row h-100"
    *ngIf="
      selectedOption != 'instructions' &&
      selectedOption != 'checklist' &&
      attachments
    "
  >
    <div class="werkbon-viewer-container"
      [class.viewer-hidden]="selectedOption === 'checklist' || selectedOption === 'instructions'">
      <div class="loader" *ngIf="isLoading"></div>
      <!-- <ng-container *ngIf="!blobPdf">
        <iframe
        (load)="loadingPDF()"
        *ngIf="src"
        [src]="src"
        class="iframe"
        frameborder="0"
        ></iframe>
      </ng-container>
      <ng-container *ngIf="blobPdf">
        <iframe
        (load)="loadingPDF()"
          [src]="pdfViewerUrl"
          width="100%"
          height="70vh"
          style="border: none;"
        ></iframe>

              </ng-container>
            </ng-container>
            <ng-container *ngIf="this.deviceInfo.deviceType == 'mobile'">

              <div class="loader" *ngIf="isLoading"></div>

              <div class="error-message" style="display: none">
                Unable to load the requested content. Please try again later.
              </div>
              <ng-container *ngIf="blobPdf">
                <iframe
                  [src]="pdfViewerUrl"
                  width="100%"
                  height="70vh"
                  style="border: none;"
                ></iframe>

            </ng-container>
            <ng-container *ngIf="!blobPdf">
    <iframe class="iframeTou" frameborder="0"></iframe> -->
      <ng-container *ngFor="let viewer of pdfViewers">
        <iframe
          #pdfViewerFrame
          [attr.data-pdf-index]="viewer.attachmentIndex"
          [src]="viewer.viewerUrl"
          [hidden]="
            viewer.attachmentIndex !== activePdfAttachmentIndex ||
            selectedOption === 'checklist' ||
            currentDocumentType !== 'pdf'
          "
          class="pdf-viewer-frame"
          title="PDF attachment preview"
          frameborder="0"
          (load)="onPdfViewerLoad(viewer)"
        ></iframe>
      </ng-container>
    </div>
<!-- </ng-container> -->
  </div>
</ng-template>
